(() => {
  'use strict';

  const i18n = window.__PW_I18N || {};
  // Shopify's |t filter HTML-encodes special chars (apostrophes → &#39;, etc.).
  // Decode via textarea so textContent assignments display correctly.
  const _dec = (() => { const el = document.createElement('textarea'); return s => { el.innerHTML = s; return el.value; }; })();
  const t = key => _dec(i18n[key] || key);

  // Feature flag: show developer debug UI on the preview step
  // (raw uncropped Gemini output + sent prompt). Set to true while
  // debugging generation issues; keep false in production.
  const DEBUG_WIZARD = false;

  // Funnel analytics: publish wizard events both to Shopify's web pixel bus
  // (subscribable from a Custom Pixel) and to the GTM/GA4 dataLayer. Events:
  // pw_wizard_step_view, pw_wizard_generate, pw_wizard_generate_success,
  // pw_wizard_generate_error, pw_wizard_add_to_cart, pw_wizard_add_to_cart_error.
  function track(eventName, data) {
    const payload = Object.assign({}, data || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (_) {}
  }

  const SHAPES = [
    { id: 'round',     name: 'Round',     dimsUnit: 'cm diam.', popular: false,
      sizes: { S: { dims: [15],    price: 29 }, L: { dims: [18],    price: 37 } } },
    { id: 'rect',      name: 'Rectangle', dimsUnit: 'cm',       popular: true,
      sizes: { S: { dims: [20,10], price: 29 }, L: { dims: [24,12], price: 37 } } },
    { id: 'rect-wide', name: 'Landscape', dimsUnit: 'cm',       popular: false,
      sizes: { S: { dims: [18,12], price: 29 }, L: { dims: [23,15], price: 37 } } },
    { id: 'square',    name: 'Square',    dimsUnit: 'cm',       popular: false,
      sizes: { S: { dims: [15,15], price: 29 }, L: { dims: [18,18], price: 37 } } },
    { id: 'shield',    name: 'Shield',    dimsUnit: 'cm',       popular: false,
      sizes: { S: { dims: [16,20], price: 37 }, L: { dims: [19,23], price: 45 } } },
  ];

  function formatDims(shape) {
    const sizeData = shape.sizes[state.size] || shape.sizes.S;
    return sizeData.dims.join(' × ') + ' ' + shape.dimsUnit;
  }

  const SIZES = [
    { id: 'S', label: 'M' },
    { id: 'L', label: 'L' },
  ];

  const BACK_COLORS = [
    { id: 'white', label: 'White', hex: '#ffffff' },
    { id: 'black', label: 'Black', hex: '#1a1a1a' },
  ];

  const STYLES = [
    { id: 'photorealistic', name: 'Photorealistic',      sub: 'Studio-grade lifelike portrait',      bg: '#2a2a2a', text: '#f5f5f5', emoji: '📷' },
    { id: 'pixar',          name: 'Pixar 3D',            sub: 'Big expressive eyes, glossy fur',     bg: '#e86c1a', text: '#fff8ef', emoji: '🎬' },
    { id: 'ghibli',         name: 'Studio Ghibli',       sub: 'Hand-painted dreamy watercolor',      bg: '#6b9e78', text: '#f5f0e8', emoji: '🌿' },
    { id: 'anime',          name: 'Anime / Manga',       sub: 'Bold cel shading, sparkling eyes',    bg: '#1a1a4e', text: '#ff6b9d', emoji: '⚡' },
    { id: 'oil-painting',   name: 'Classical Oil',       sub: 'Museum-worthy impasto brushstrokes',  bg: '#4a2c0a', text: '#f5e6c8', emoji: '🖌️' },
    { id: 'renaissance',    name: 'Renaissance Royal',   sub: 'Velvet, lace & a regal crown',        bg: '#1a0a2e', text: '#d4af37', emoji: '👑' },
    { id: 'comic',          name: 'Comic Book',          sub: 'Bold outlines, halftone dots & BAM!', bg: '#cc1a2a', text: '#fff200', emoji: '💥' },
    { id: 'disney',         name: 'Disney Classic',      sub: 'Hand-drawn warmth, Lady & the Tramp', bg: '#1a3a6b', text: '#ffd700', emoji: '✨' },
    { id: 'watercolor',     name: 'Watercolor Wash',     sub: 'Soft airy bleeds, gallery style',     bg: '#4a7fa5', text: '#fdf6ff', emoji: '🎨' },
    { id: 'pencil',         name: 'Pencil Sketch',       sub: 'Black-and-white graphite artistry',   bg: '#f0f0f0', text: '#1a1a1a', emoji: '✏️' },
    { id: 'pop-art',        name: 'Pop Art (Warhol)',     sub: 'Four bold screen-print color panels', bg: '#cc0066', text: '#ffff00', emoji: '🎭' },
    { id: 'van-gogh',       name: 'Van Gogh',            sub: 'Swirling strokes, Starry Night mood', bg: '#1a2e6b', text: '#ffd700', emoji: '🌀' },
    { id: 'minimalist',     name: 'Minimalist Line Art',  sub: 'Single elegant continuous line',      bg: '#f0f0eb', text: '#1a1a1a', emoji: '◻️' },
    { id: 'cyberpunk',      name: 'Cyberpunk Neon',      sub: 'Glowing magenta & cyan night vibes',  bg: '#0d0d1a', text: '#ff00ff', emoji: '🌆' },
    { id: 'pixel-art',      name: 'Pixel Art 16-bit',    sub: 'Retro arcade sprite, SNES style',     bg: '#1a0a2e', text: '#00ff88', emoji: '👾' },
    { id: 'low-poly',       name: 'Low Poly',            sub: 'Faceted triangles, crystalline',      bg: '#1a3a5a', text: '#e8f4ff', emoji: '🔷' },
    { id: 'kawaii',         name: 'Kawaii Chibi',        sub: 'Huge head, pastel hearts, adorable',  bg: '#ffb6c1', text: '#9b1a5e', emoji: '🌸' },
    { id: 'stained-glass',  name: 'Stained Glass',       sub: 'Jewel-toned glass panels, sacred',    bg: '#1a0a4a', text: '#ffd700', emoji: '⛪' },
    { id: 'tattoo',         name: 'Traditional Tattoo',  sub: 'Bold outlines, classic flash colors', bg: '#1a1a1a', text: '#ff6b35', emoji: '⚓' },
    { id: 'art-nouveau',    name: 'Art Nouveau',         sub: 'Flowing botanicals, Mucha style',     bg: '#3d2b0e', text: '#c9a96e', emoji: '🌺' },
    { id: 'dark-comic',     name: 'Dark Comic Noir',     sub: 'Ink shadows, rain-slick night city',  bg: '#0e1116', text: '#f2c14e', emoji: '🦇' },
    { id: 'ukiyo-e',        name: 'Ukiyo-e Woodblock',   sub: 'Japanese print, waves & indigo',      bg: '#1b3a5c', text: '#f0e2c8', emoji: '🌊' },
    { id: 'steampunk',      name: 'Steampunk Brass',     sub: 'Cogs, goggles & gaslight glow',       bg: '#3b2412', text: '#d8a24a', emoji: '⚙️' },
    { id: 'graffiti',       name: 'Street Graffiti',     sub: 'Spray-paint mural, wildstyle tags',   bg: '#151515', text: '#39ff6a', emoji: '🧱' },
    { id: 'claymation',     name: 'Claymation',          sub: 'Handmade plasticine stop-motion',     bg: '#c96a3f', text: '#fff3e2', emoji: '🏺' },
    { id: 'embroidery',     name: 'Embroidered Patch',   sub: 'Stitched threads on woven fabric',    bg: '#7d2b3c', text: '#f6e7d4', emoji: '🧵' },
    { id: 'storybook',      name: 'Storybook',           sub: 'Soft children\'s picture-book art',   bg: '#f5e6d3', text: '#5c3d2e', emoji: '📖' },
  ];

  const STEP_LABELS = () => [t('step_shape_label'), t('step_style_label'), t('step_pet_label'), t('step_finish_label')];
  const STEP_TITLES = () => [t('step_shape_title'), t('step_style_title'), t('step_pet_title'), t('step_finish_title')];

  const SHAPE_PREVIEW_SIZE = {
    round: 72, rect: 100, 'rect-wide': 90,
    square: 80, shield: 70,
  };

  const root = document.getElementById('dw-root');
  if (!root) return;

  let STYLE_IMAGES = {};
  try { STYLE_IMAGES = JSON.parse(root.dataset.styleImages || '{}'); } catch (_) {}

  const els = {
    sidebarSteps:  root.querySelector('[data-dw-sidebar-steps]'),
    breadcrumbStep:root.querySelector('[data-dw-breadcrumb-step]'),
    priceValue:    root.querySelector('[data-dw-price-value]'),
    priceRows:     root.querySelector('[data-dw-price-rows]'),
    shippingNudgeTotal:  root.querySelector('[data-dw-shipping-nudge-total]'),
    shippingNudgeFooter: root.querySelector('[data-dw-shipping-nudge-footer]'),
    panes:         root.querySelectorAll('[data-dw-step]'),
    shapeGrid:     root.querySelector('[data-dw-shape-grid]'),
    sizeTabs:      root.querySelector('[data-dw-size-tabs]'),
    backColorTabs: root.querySelector('[data-dw-back-color-tabs]'),
    petUpload:     root.querySelector('[data-dw-pet-upload]'),
    petUploadInput:root.querySelector('[data-dw-pet-file]'),
    petUploadClear:root.querySelector('[data-dw-pet-clear]'),
    petModeToggle: root.querySelector('[data-dw-pet-mode]'),
    petPanes:      root.querySelectorAll('[data-dw-pet-pane]'),
    breedInput:    root.querySelector('[data-dw-breed]'),
    personalityInput: root.querySelector('[data-dw-personality]'),
    bgDescription: root.querySelector('[data-dw-bg-description]'),
    styleChips:    root.querySelector('[data-dw-style-chips]'),
    styleCustom:   root.querySelector('[data-dw-style-custom]'),
    customWrap:    root.querySelector('[data-dw-custom-wrap]'),
    styleImage:    root.querySelector('[data-dw-style-image]'),
    styleImageWrap:root.querySelector('[data-dw-style-image-wrap]'),
    styleImageUpload: root.querySelector('[data-dw-style-image-upload]'),
    styleImageInput: root.querySelector('[data-dw-style-image-file]'),
    styleImageClear: root.querySelector('[data-dw-style-image-clear]'),
    stylePreviewImg:  root.querySelector('[data-dw-style-img]'),
    stylePreviewName: root.querySelector('[data-dw-style-name]'),
    stylePreviewDesc: root.querySelector('[data-dw-style-desc]'),
    signTextInput: root.querySelector('[data-dw-sign-text]'),
    textStyleInput: root.querySelector('[data-dw-text-style]'),
    bevelToggle:   root.querySelector('[data-dw-bevel]'),
    bevelNote:     root.querySelector('[data-dw-bevel-note]'),
    bevelCompareItems: Array.from(root.querySelectorAll('.dw__bevel-compare-item')),
    recap:         root.querySelector('[data-dw-recap]'),
    totalValue:    root.querySelector('[data-dw-total]'),
    btnPrev:       root.querySelector('[data-dw-prev]'),
    btnNext:       root.querySelector('[data-dw-next]'),
    dots:          root.querySelector('[data-dw-dots]'),
    content:       root.querySelector('[data-dw-content]'),
    previewPlaceholder: root.querySelector('[data-dw-preview-placeholder]'),
    previewLoading: root.querySelector('[data-dw-preview-loading]'),
    previewImg:    root.querySelector('[data-dw-preview-img]'),
    previewError:  root.querySelector('[data-dw-preview-error]'),
    previewStale:  root.querySelector('[data-dw-preview-stale]'),
    previewUnchanged: root.querySelector('[data-dw-preview-unchanged]'),
    rating:        root.querySelector('[data-dw-rating]'),
    ratingUp:      root.querySelector('[data-dw-rating-up]'),
    ratingDown:    root.querySelector('[data-dw-rating-down]'),
    ratingDetails: root.querySelector('[data-dw-rating-details]'),
    ratingReasons: root.querySelectorAll('[data-dw-rating-reason]'),
    ratingReasonsLegend: root.querySelector('[data-dw-rating-reasons-legend]'),
    ratingReasonLabels: root.querySelectorAll('[data-dw-rating-reason-label]'),
    ratingComment: root.querySelector('[data-dw-rating-comment]'),
    ratingSubmit:  root.querySelector('[data-dw-rating-submit]'),
    ratingThanks:  root.querySelector('[data-dw-rating-thanks]'),
    loginGate:     root.querySelector('[data-dw-login-gate]'),
    loginGateCta:  root.querySelector('[data-dw-login-cta]'),
    btnGenerate:   root.querySelector('[data-dw-generate]'),
    btnGenerateLabel: root.querySelector('[data-dw-generate-label]'),
    progressFill:  root.querySelector('[data-dw-progress-fill]'),
    progressTime:  root.querySelector('[data-dw-progress-time]'),
    genLimit:      root.querySelector('[data-dw-gen-limit]'),
    genCount:      root.querySelector('[data-dw-gen-count]'),
    genTotal:      root.querySelector('[data-dw-gen-total]'),
    genLabel:      root.querySelector('[data-dw-gen-label]'),
    genDots:       root.querySelector('[data-dw-gen-dots]'),
    genNote:       root.querySelector('[data-dw-gen-note]'),
    debugRaw:      DEBUG_WIZARD ? root.querySelector('[data-dw-debug-raw]') : null,
    debugRawImg:   DEBUG_WIZARD ? root.querySelector('[data-dw-debug-raw-img]') : null,
    debugPrompt:   DEBUG_WIZARD ? root.querySelector('[data-dw-debug-prompt]') : null,
    debugPromptText: DEBUG_WIZARD ? root.querySelector('[data-dw-debug-prompt-text]') : null,
  };

  const TIMER_TOTAL_MS = 30000;
  const RING_CIRCUMFERENCE = 2 * Math.PI * 44;

  const GENERATION_LIMIT = 5;
  const GEN_LIMIT_KEY = 'pw_gen_limit';

  // ── Account gate ─────────────────────────────────────────────────────────
  // Anonymous visitors get FREE_GENERATIONS previews; generating beyond that
  // requires a Shopify customer account. The wizard state (selections, uploads,
  // the preview already generated) lives in localStorage, so after login the
  // customer lands back on this page with everything exactly where they left it.
  const CUSTOMER_LOGGED_IN = root.dataset.customerLoggedIn === '1';
  // Email / first name are only present when Shopify rendered a logged-in
  // customer. Used to identify the profile in Klaviyo before tracking
  // Generated Sign Preview (first_name powers {{ first_name }} in emails).
  const CUSTOMER_EMAIL = (root.dataset.customerEmail || '').trim();
  const CUSTOMER_FIRST_NAME = (root.dataset.customerFirstName || '').trim();
  // Storefront language ('it', 'en', …). Klaviyo emails render an hour after the
  // event, so the language has to travel with the profile — the request locale is
  // long gone by then.
  const LOCALE = (root.dataset.locale || 'en').trim().toLowerCase().slice(0, 2);
  // Where the visitor is, for the admin audit page's origin flag. The server
  // resolves one country out of these three (cloud-run/src/geo.ts) — the time
  // zone wins, because the Shopify market is the same code for everyone in a
  // single-market store. Nothing here is new information about the customer:
  // it is what every request already carries, just made legible.
  const SHOP_COUNTRY = (root.dataset.country || '').trim().toUpperCase().slice(0, 2);
  const TIMEZONE = (function () {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (err) { return ''; }
  })();
  const LANGUAGE = (typeof navigator !== 'undefined' && navigator.language) || '';
  // The three fields both /preview and /cart-add read, so a design's origin
  // and its add-to-cart agree on where the customer was.
  function originFields() {
    return { timezone: TIMEZONE, language: LANGUAGE, country: SHOP_COUNTRY };
  }
  const LOGIN_URL = root.dataset.loginUrl || '/account/login';
  const FREE_GENERATIONS = 1;
  // Logged-out generations are counted separately from GEN_LIMIT_KEY: that one
  // is a daily budget, this one must not reset overnight or the gate would hand
  // out a fresh free preview every day.
  const FREE_GEN_KEY = 'pw_free_gens';
  // Set right before we send the visitor to the account pages; on the way back
  // it tells us to scroll them straight to the preview they were working on.
  // localStorage rather than sessionStorage on purpose: the login email's magic
  // link can open a *new* tab, and the customer then comes back in that one —
  // sessionStorage would be empty there. The timestamp keeps the marker from
  // outliving the sign-in journey it belongs to.
  const LOGIN_RETURN_KEY = 'pw_login_gate_pending';
  const LOGIN_RETURN_TTL_MS = 30 * 60 * 1000;
  // Which gate sent them off — today only 'preview' (out of free generations);
  // adding to cart is open to everyone. Kept beside the timestamp rather than
  // encoded into it so the marker's own format — and everything already reading
  // it — stays exactly as it was. It decides only what we say and where we
  // point their eye on the way back.
  const LOGIN_INTENT_KEY = 'pw_login_gate_intent';

  function markLoginPending(intent) {
    try {
      localStorage.setItem(LOGIN_RETURN_KEY, String(Date.now()));
      if (intent) localStorage.setItem(LOGIN_INTENT_KEY, intent);
      else localStorage.removeItem(LOGIN_INTENT_KEY);
    } catch {}
  }

  function loginIntent() {
    try { return localStorage.getItem(LOGIN_INTENT_KEY) || ''; } catch { return ''; }
  }

  function isLoginPending() {
    try {
      const raw = localStorage.getItem(LOGIN_RETURN_KEY);
      if (!raw) return false;
      const startedAt = parseInt(raw, 10) || 0;
      if (Date.now() - startedAt < LOGIN_RETURN_TTL_MS) return true;
      localStorage.removeItem(LOGIN_RETURN_KEY);
      return false;
    } catch { return false; }
  }

  function clearLoginPending() {
    try {
      localStorage.removeItem(LOGIN_RETURN_KEY);
      localStorage.removeItem(LOGIN_INTENT_KEY);
    } catch {}
  }

  function getFreeGenCount() {
    try { return parseInt(localStorage.getItem(FREE_GEN_KEY) || '0', 10) || 0; } catch { return 0; }
  }

  function setFreeGenCount(count) {
    try { localStorage.setItem(FREE_GEN_KEY, String(count)); } catch {}
  }

  function needsLogin() {
    return !CUSTOMER_LOGGED_IN && state.freeGenerationsUsed >= FREE_GENERATIONS;
  }

  // Off to the account pages, and back to this exact design afterwards. Flushing
  // the debounced save first is what makes the round trip lossless: everything
  // the customer configured is in localStorage before we navigate away.
  function goToLogin(intent) {
    if (saveStateTimer) clearTimeout(saveStateTimer);
    saveState();
    markLoginPending(intent);
  }

  // Send the customer back to this exact page (query string included) once
  // they're signed in. New customer accounts take `return_to` on
  // /customer_authentication/login; classic accounts take `return_url` on
  // /account/login. Both only accept relative URLs.
  //
  // Liquid already renders storefront_login_url with a return_to of its own —
  // the bare page path, no query string. Appending a second copy of the param
  // left Shopify with a duplicate to choose from, and the one it kept dropped
  // whatever the wizard was opened with (?style=…), so set the value in place.
  function withReturnUrl(base) {
    const here = window.location.pathname + window.location.search;
    const param = base.indexOf('/customer_authentication') >= 0 ? 'return_to' : 'return_url';
    try {
      const url = new URL(base, window.location.origin);
      url.searchParams.set(param, here);
      return url.origin === window.location.origin
        ? url.pathname + url.search
        : url.toString();
    } catch {
      return base + (base.indexOf('?') >= 0 ? '&' : '?') + param + '=' + encodeURIComponent(here);
    }
  }

  function getGenUsage() {
    try {
      const raw = localStorage.getItem(GEN_LIMIT_KEY);
      if (!raw) return { date: '', count: 0 };
      const obj = JSON.parse(raw);
      const today = new Date().toISOString().slice(0, 10);
      if (obj.date !== today) return { date: today, count: 0 };
      return { date: obj.date, count: typeof obj.count === 'number' ? obj.count : 0 };
    } catch { return { date: '', count: 0 }; }
  }

  function setGenUsage(count) {
    try {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem(GEN_LIMIT_KEY, JSON.stringify({ date: today, count }));
    } catch {}
  }

  // Signatures (previewSignature()) of the briefs already generated today. This
  // backs the "nothing changed, nothing will change" notice for the case the
  // full wizard snapshot can't cover: that snapshot is a ~20-field blob with
  // base64 photos, and in-app browsers (Instagram / Facebook) routinely fail to
  // persist it across the redirect to /cart and back — so on return the preview
  // is gone, isPreviewUnchanged() is false, and the Generate button goes live on
  // an identical brief. This list is ~200 bytes, written to BOTH stores, so it
  // survives a partial wipe; sessionStorage in particular survives the cart
  // round-trip even when localStorage is flaky. Day-scoped like GEN_LIMIT_KEY —
  // the warning shouldn't outlive the daily generation budget it mirrors.
  const GEN_SIGS_KEY = 'pw_gen_sigs';
  const GEN_SIGS_MAX = 12;
  const generatedSigs = new Set();

  function readGenSigs(store) {
    try {
      const today = new Date().toISOString().slice(0, 10);
      const obj = JSON.parse(store.getItem(GEN_SIGS_KEY) || '{}');
      return obj && obj.date === today && Array.isArray(obj.sigs) ? obj.sigs : [];
    } catch { return []; }
  }

  function loadGeneratedSigs() {
    for (const store of [safeStore('local'), safeStore('session')]) {
      if (!store) continue;
      for (const sig of readGenSigs(store)) generatedSigs.add(sig);
    }
  }

  function safeStore(kind) {
    try { return kind === 'session' ? window.sessionStorage : window.localStorage; }
    catch { return null; }
  }

  function rememberGeneratedSig(sig) {
    if (!sig) return;
    generatedSigs.add(sig);
    const today = new Date().toISOString().slice(0, 10);
    const sigs = Array.from(generatedSigs).slice(-GEN_SIGS_MAX);
    const payload = JSON.stringify({ date: today, sigs });
    for (const store of [safeStore('local'), safeStore('session')]) {
      try { if (store) store.setItem(GEN_SIGS_KEY, payload); } catch {}
    }
  }

  function sigAlreadyGenerated(sig) {
    return !!sig && generatedSigs.has(sig);
  }

  const state = {
    step: 0,
    shape: 'rect',
    size: 'S',
    backColor: 'white',
    petMode: 'describe', // 'describe' | 'upload'
    breed: '',
    personality: '',
    petImageUrl: null,
    petImageData: null,
    petImageMime: 'image/jpeg',
    bgDescription: '',
    style: 'photorealistic',
    styleMode: 'preset', // 'preset' | 'custom' | 'image'
    customStyle: '',
    styleImageUrl: null,
    styleImageData: null,
    styleImageMime: 'image/jpeg',
    signText: '',
    textStyle: '',
    bevel: false,
    stylePreFilled: false,
    previewUrl: null, // GCS URL of the generated preview (returned by /preview)
    previewShape: null, // shape used when the current preview was generated; drives client-side clip
    previewPrompt: null,
    previewSignature: '',
    // Rating of the current preview. ratingFor pins it to the image it was
    // left on, so a refresh restores it but a fresh generation doesn't inherit it.
    ratingFor: null,
    ratingVerdict: null, // 'up' | 'down'
    ratingReasons: [],
    ratingComment: '',
    ratingDetailsOpen: false,
    ratingSent: false,
    generating: false,
    previewError: false,
    generationsUsed: getGenUsage().count,
    freeGenerationsUsed: getFreeGenCount(), // generations made while logged out
    discountCode: '',
    showErrors: { 0: false, 1: false, 2: false, 3: false },
    timerInterval: null,
  };

  // ── Wizard state persistence ─────────────────────────────────────────────
  // Survive page refresh so users don't lose selections + uploaded images.
  // Transient fields (generating, previewError, timerInterval) are skipped.
  // generationsUsed has its own daily-scoped key (GEN_LIMIT_KEY).
  const WIZARD_STATE_KEY = 'pw_wizard_state';
  // v2: previewUrl is now a GCS URL (server-side upload) instead of a base64
  // data URL — bumping the version drops any heavy legacy base64 snapshots.
  const WIZARD_STATE_VERSION = 2;
  const PERSIST_FIELDS = [
    'step', 'shape', 'size', 'backColor',
    'petMode', 'breed', 'personality',
    'petImageData', 'petImageMime',
    'bgDescription',
    'style', 'styleMode', 'customStyle', 'stylePreFilled',
    'styleImageData', 'styleImageMime',
    'signText', 'textStyle', 'bevel',
    'previewUrl', 'previewShape', 'previewPrompt', 'previewSignature',
    'ratingFor', 'ratingVerdict', 'ratingReasons', 'ratingComment', 'ratingSent',
  ];

  function trySaveSnapshot(snap) {
    try {
      localStorage.setItem(WIZARD_STATE_KEY, JSON.stringify(snap));
      return true;
    } catch {
      return false;
    }
  }

  function saveState() {
    const snap = { __v: WIZARD_STATE_VERSION, savedAt: Date.now() };
    for (const f of PERSIST_FIELDS) snap[f] = state[f];
    if (trySaveSnapshot(snap)) return;
    // Quota exceeded: drop the heavy base64 upload blobs and retry. previewUrl
    // is now just a GCS URL, so it stays — the preview survives a refresh.
    snap.petImageData = null;
    snap.styleImageData = null;
    trySaveSnapshot(snap);
  }

  let saveStateTimer = null;
  function scheduleSave() {
    if (saveStateTimer) clearTimeout(saveStateTimer);
    saveStateTimer = setTimeout(saveState, 250);
  }

  function loadState() {
    let obj;
    try {
      const raw = localStorage.getItem(WIZARD_STATE_KEY);
      if (!raw) return;
      obj = JSON.parse(raw);
    } catch {
      return;
    }
    if (!obj || obj.__v !== WIZARD_STATE_VERSION) return;
    const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
    if (obj.savedAt && Date.now() - obj.savedAt > ONE_WEEK_MS) {
      try { localStorage.removeItem(WIZARD_STATE_KEY); } catch {}
      return;
    }
    for (const f of PERSIST_FIELDS) {
      if (obj[f] !== undefined) state[f] = obj[f];
    }
    // Object URLs from File uploads don't survive refresh, but we still have
    // the base64 payload — reconstruct as data: URLs for the preview tiles.
    if (state.petImageData) {
      state.petImageUrl = 'data:' + (state.petImageMime || 'image/jpeg') + ';base64,' + state.petImageData;
    }
    if (state.styleImageData) {
      state.styleImageUrl = 'data:' + (state.styleImageMime || 'image/jpeg') + ';base64,' + state.styleImageData;
    }
    // <input>/<textarea> values aren't auto-restored from JS state — sync them.
    if (els.breedInput) els.breedInput.value = state.breed || '';
    if (els.personalityInput) els.personalityInput.value = state.personality || '';
    if (els.bgDescription) els.bgDescription.value = state.bgDescription || '';
    if (els.signTextInput) els.signTextInput.value = state.signText || '';
    if (els.textStyleInput) els.textStyleInput.value = state.textStyle || '';
    const customTextEl = root.querySelector('[data-dw-custom-text]');
    if (customTextEl) customTextEl.value = state.customStyle || '';
  }

  // Any user interaction inside the wizard root triggers a debounced save.
  // Async flows (uploads, generation) call scheduleSave() explicitly when
  // their results land after the originating click event has already fired.
  root.addEventListener('input', scheduleSave, true);
  root.addEventListener('change', scheduleSave, true);
  root.addEventListener('click', scheduleSave, true);

  // ── Required-field validation ────────────────────────────────────────────
  function getStepErrors(step) {
    const e = {};
    if (step === 1) {
      if (state.styleMode === 'custom' && !state.customStyle.trim()) {
        e.customStyle = t('error_custom_style_required');
      } else if (state.styleMode === 'image' && !state.styleImageData) {
        e.styleImage = t('error_style_image_required');
      }
    } else if (step === 2) {
      if (state.petMode === 'describe' && !state.breed.trim()) {
        e.subject = t('error_subject_required');
      }
      if (state.petMode === 'upload' && !state.petImageData) {
        e.subject = t('error_subject_required');
      }
      if (!state.bgDescription.trim()) {
        e.bgDescription = t('error_bg_describe_required');
      }
    } else if (step === 3) {
      if (!normaliseSignText(state.signText)) {
        e.signText = t('error_sign_text_required');
      }
    }
    return e;
  }
  function isStepValid(step) { return Object.keys(getStepErrors(step)).length === 0; }
  function isAllValid() { return [0, 1, 2, 3].every(isStepValid); }
  function firstInvalidStep() { return [0, 1, 2, 3].find(i => !isStepValid(i)); }
  function visibleErrors(step) {
    return state.showErrors[step] ? getStepErrors(step) : {};
  }
  function errorMsg(text) {
    return text ? `<div class="dw__error-msg">⚠ ${escapeHtml(text)}</div>` : '';
  }

  const PREVIEW_ENDPOINT = '/apps/pawsitive/preview';
  const WARM_ENDPOINT = '/apps/pawsitive/warm';
  const CART_ADD_TRACK_ENDPOINT = '/apps/pawsitive/cart-add';
  const RATING_ENDPOINT = '/apps/pawsitive/rating';

  function pingWarm() {
    fetch(WARM_ENDPOINT, { method: 'GET', credentials: 'same-origin' }).catch(() => {});
  }

  // ── Sign SVG ─────────────────────────────────────────────────────────────
  function signSVG(shape, styleId, line1, line2, size) {
    const style = STYLES.find(s => s.id === styleId) || { bg: '#264653', text: '#e9c46a' };
    const W = size;
    const xmlns = 'http://www.w3.org/2000/svg';
    const text = (w, h, cx, cy) => {
      const safe2 = (line2 || 'YOUR PET').toUpperCase();
      const trimmed = safe2.length > 12 ? safe2.slice(0, 12) + '…' : safe2;
      return (
        `<text x="${cx}" y="${cy - h * 0.2}" text-anchor="middle" font-family="var(--font-heading-family, 'Fredoka', sans-serif)" font-size="${w * 0.056}" font-weight="600" fill="${style.text}" letter-spacing="2" opacity="0.82">⚠ ${escapeXml((line1 || 'BEWARE OF').toUpperCase())} ⚠</text>` +
        `<text x="${cx}" y="${cy + h * 0.06}" text-anchor="middle" font-family="var(--font-heading-family, 'Fredoka', sans-serif)" font-size="${w * 0.11}" font-weight="700" fill="${style.text}">${escapeXml(trimmed)}</text>`
      );
    };
    const filter = `<defs><filter id="ds-${shape}-${size}"><feDropShadow dx="0" dy="5" stdDeviation="7" flood-opacity="0.28"/></filter></defs>`;
    const f = `filter="url(#ds-${shape}-${size})"`;

    // Thumbnails mirror the finished-sign proportions in cloud-run/src/validate.ts:
    //   round 1:1, rect 2:1 ([20,10]/[24,12]) — Gemini generates 21:9 and the
    //   sides are cropped to 2:1, rect-wide 3:2 ([18,12]/[23,15]),
    //   square 1:1, shield 4:5 ([16,20]/[19,23]).
    if (shape === 'round') {
      return `<svg width="${W}" height="${W}" viewBox="0 0 200 200" xmlns="${xmlns}">${filter}<circle cx="100" cy="100" r="90" fill="${style.bg}" ${f}/><circle cx="100" cy="100" r="83" fill="none" stroke="${style.text}" stroke-width="2" opacity="0.28"/>${text(180, 180, 100, 100)}</svg>`;
    }
    if (shape === 'rect') {
      return `<svg width="${W}" height="${W * 0.5}" viewBox="0 0 200 100" xmlns="${xmlns}">${filter}<rect x="4" y="4" width="192" height="92" rx="10" fill="${style.bg}" ${f}/><rect x="12" y="12" width="176" height="76" rx="6" fill="none" stroke="${style.text}" stroke-width="1.5" opacity="0.22"/>${text(180, 86, 100, 50)}</svg>`;
    }
    if (shape === 'rect-wide') {
      return `<svg width="${W}" height="${W * 0.667}" viewBox="0 0 240 160" xmlns="${xmlns}">${filter}<rect x="6" y="6" width="228" height="148" rx="14" fill="${style.bg}" ${f}/><rect x="18" y="18" width="204" height="124" rx="8" fill="none" stroke="${style.text}" stroke-width="2" opacity="0.22"/>${text(200, 118, 120, 82)}</svg>`;
    }
    if (shape === 'square') {
      return `<svg width="${W}" height="${W}" viewBox="0 0 200 200" xmlns="${xmlns}">${filter}<rect x="6" y="6" width="188" height="188" rx="14" fill="${style.bg}" ${f}/><rect x="18" y="18" width="164" height="164" rx="8" fill="none" stroke="${style.text}" stroke-width="2" opacity="0.22"/>${text(160, 160, 100, 100)}</svg>`;
    }
    if (shape === 'shield') {
      return `<svg width="${W}" height="${W * 1.25}" viewBox="0 0 200 250" xmlns="${xmlns}">${filter}<path d="M100,240 L8,184 L8,22 Q8,8 22,8 L178,8 Q192,8 192,22 L192,184 Z" fill="${style.bg}" ${f}/><path d="M100,224 L22,176 L22,28 Q22,20 30,20 L170,20 Q178,20 178,28 L178,176 Z" fill="none" stroke="${style.text}" stroke-width="1.5" opacity="0.22"/>${text(156, 200, 100, 118)}</svg>`;
    }
    return '';
  }

  function escapeXml(s) {
    return String(s).replace(/[<>&"']/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&apos;' }[c]));
  }

  function escapeHtml(s) {
    return String(s).replace(/[<>&"']/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function idKey(id) { return id.replace(/-/g, '_'); }
  function sizeLabelKey(id) { return id === 'S' ? 'M' : id; }

  // ── Derived values ───────────────────────────────────────────────────────
  function getShape() { return SHAPES.find(s => s.id === state.shape) || SHAPES[1]; }
  function getSize()  { return SIZES.find(s => s.id === state.size) || SIZES[1]; }
  function getStyle() { return STYLES.find(s => s.id === state.style) || STYLES[0]; }
  function basePrice() {
    const shape = getShape();
    return (shape.sizes[state.size] || shape.sizes.S).price;
  }
  function totalPrice() { return basePrice(); }

  const FREE_SHIPPING_THRESHOLD = 39;
  const SHIP_TRUCK_SVG = '<svg class="dw__ship-nudge-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="6" width="14" height="11" rx="1"/><path d="M15 9h4l3 4v4h-7V9z"/><circle cx="6" cy="19" r="1.6"/><circle cx="18" cy="19" r="1.6"/></svg>';
  const SHIP_CHECK_SVG = '<svg class="dw__ship-nudge-icon dw__ship-nudge-icon--check" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function formatEur(amount) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return '€0';
    if (Number.isInteger(n)) return '€' + n;
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function formatEurPlain(amount) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return '0';
    if (Number.isInteger(n)) return String(n);
    return n.toFixed(2).replace('.', ',');
  }

  // ── Renderers ────────────────────────────────────────────────────────────
  function renderUploadArea(el, clearEl, imageUrl, { icon, titleKey, subKey, altText, optional }) {
    if (imageUrl) {
      el.classList.add('has-image');
      el.innerHTML = `
        <img src="${imageUrl}" class="dw__upload-preview" alt="${escapeHtml(altText)}" decoding="async"/>
        <div style="margin-top:8px;font-size:12px;color:var(--dw-soft);">${t('upload_change')}</div>`;
      if (clearEl) clearEl.hidden = false;
    } else {
      el.classList.remove('has-image');
      el.innerHTML = `
        <div class="dw__upload-icon">${icon}</div>
        <div class="dw__upload-title">${t(titleKey)}</div>
        ${optional ? `<div class="dw__optional">${t('optional')}</div>` : ''}
        <div class="dw__upload-sub">${t(subKey)}</div>`;
      if (clearEl) clearEl.hidden = true;
    }
  }

  function renderShapes() {
    els.shapeGrid.innerHTML = SHAPES.map(s => {
      const sizeData = s.sizes[state.size] || s.sizes.S;
      const price = sizeData.price;
      const name = t('shape_' + idKey(s.id)) || s.name;
      const dims = formatDims(s);
      return `
        <button type="button" class="dw__shape ${state.shape === s.id ? 'is-selected' : ''}" data-shape-id="${s.id}">
          ${s.popular ? `<div class="dw__shape-badge">${t('shape_popular')}</div>` : ''}
          <div class="dw__shape-preview">${signSVG(s.id, state.style || 'coastal', 'BEWARE', 'THE PET', SHAPE_PREVIEW_SIZE[s.id] || 70)}</div>
          <div class="dw__shape-name">${escapeHtml(name)}</div>
          <div class="dw__shape-dims">${escapeHtml(dims)}</div>
          <div class="dw__shape-price">${t('shape_from')} €${price}</div>
        </button>`;
    }).join('');
  }

  function renderSizes() {
    const shape = getShape();
    els.sizeTabs.innerHTML = SIZES.map(sz => {
      const sizeData = shape.sizes[sz.id];
      const price = sizeData.price;
      const label = t('size_' + sizeLabelKey(sz.id) + '_label') || sz.label;
      const dims = sizeData.dims.join(' × ') + ' ' + shape.dimsUnit;
      return `
        <button type="button" class="dw__size ${state.size === sz.id ? 'is-selected' : ''}" data-size-id="${sz.id}">
          <div class="dw__size-name">${escapeHtml(label)}</div>
          <div class="dw__size-dim">${escapeHtml(dims)}</div>
          <div class="dw__size-price">€${price}</div>
        </button>`;
    }).join('');
  }

  function renderBackColors() {
    if (!els.backColorTabs) return;
    els.backColorTabs.innerHTML = BACK_COLORS.map(bc => {
      const label = t('back_color_' + bc.id) || bc.label;
      const selected = state.backColor === bc.id;
      return `
        <button type="button" class="dw__back-color ${selected ? 'is-selected' : ''}" data-back-color="${bc.id}">
          <span class="dw__back-color-swatch" style="background:${bc.hex};border-color:${bc.id === 'white' ? '#d0d0d0' : bc.hex};"></span>
          <span class="dw__back-color-name">${escapeHtml(label)}</span>
        </button>`;
    }).join('');
  }

  function renderPetMode() {
    if (!els.petModeToggle) return;
    els.petModeToggle.querySelectorAll('button').forEach(btn => {
      const active = btn.dataset.petMode === state.petMode;
      btn.classList.toggle('is-active', active);
      // role="radio": the checked option is the group's single tab stop, and
      // the arrows move between them (see the keydown handler below).
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
      btn.tabIndex = active ? 0 : -1;
    });
    els.petPanes.forEach(pane => {
      pane.hidden = pane.dataset.dwPetPane !== state.petMode;
    });
    const errs = visibleErrors(2);
    const invalid = !!errs.subject;
    if (els.breedInput) els.breedInput.classList.toggle('is-invalid', invalid && state.petMode === 'describe');
    if (els.petUpload)  els.petUpload.classList.toggle('is-invalid',  invalid && state.petMode === 'upload');
    const petErrEl = root.querySelector('[data-dw-pet-error]');
    if (petErrEl) petErrEl.innerHTML = errorMsg(errs.subject);
  }

  function renderPetUpload() {
    renderUploadArea(els.petUpload, els.petUploadClear, state.petImageUrl, {
      icon: '📸', titleKey: 'upload_pet_title', subKey: 'upload_pet_sub', altText: 'Pet upload preview',
    });
  }

  function renderBgDescription() {
    const errs = visibleErrors(2);
    els.bgDescription.classList.toggle('is-invalid', !!errs.bgDescription);
    const bgErrEl = root.querySelector('[data-dw-bg-error]');
    if (bgErrEl) bgErrEl.innerHTML = errorMsg(errs.bgDescription);
  }

  function renderStyles() {
    const isCustom = state.styleMode === 'custom';
    const isImage  = state.styleMode === 'image';
    els.styleChips.innerHTML = STYLES.map(s => {
      const name = t('style_' + idKey(s.id) + '_name') || s.name;
      const sub = t('style_' + idKey(s.id) + '_sub') || s.sub;
      const selected = !isCustom && !isImage && state.style === s.id;
      return `
        <button type="button" class="dw__style-chip ${selected ? 'is-selected' : ''}" data-style-id="${s.id}">
          <div class="dw__style-swatch" style="background:${s.bg};"><span>${s.emoji}</span></div>
          <div>
            <div class="dw__style-name">${name}</div>
            <div class="dw__style-sub">${sub}</div>
          </div>
          ${selected ? '<div class="dw__style-check">✓</div>' : ''}
        </button>`;
    }).join('');

    els.styleCustom.classList.toggle('is-selected', isCustom);
    els.styleCustom.innerHTML = `
      <div class="dw__style-swatch" style="background:#e8f4f2;border:1.5px dashed var(--dw-divider);">✏️</div>
      <div>
        <div class="dw__style-name">${t('style_custom_name')}</div>
        <div class="dw__style-sub">${t('style_custom_sub')}</div>
      </div>
      ${isCustom ? '<div class="dw__style-check">✓</div>' : ''}`;
    els.customWrap.hidden = !isCustom;
    const customTextEl = root.querySelector('[data-dw-custom-text]');
    if (customTextEl && customTextEl.value !== state.customStyle) {
      customTextEl.value = state.customStyle;
    }
    const errs = visibleErrors(1);
    if (customTextEl) customTextEl.classList.toggle('is-invalid', !!errs.customStyle);
    const customErrEl = root.querySelector('[data-dw-custom-error]');
    if (customErrEl) customErrEl.innerHTML = errorMsg(errs.customStyle);
    if (els.styleImageUpload) els.styleImageUpload.classList.toggle('is-invalid', !!errs.styleImage);
    const styleImgErrEl = root.querySelector('[data-dw-style-image-error]');
    if (styleImgErrEl) styleImgErrEl.innerHTML = errorMsg(errs.styleImage);

    if (els.styleImage) {
      els.styleImage.classList.toggle('is-selected', isImage);
      els.styleImage.innerHTML = `
        <div class="dw__style-swatch" style="background:#fdeee6;border:1.5px dashed var(--dw-divider);">🖼️</div>
        <div>
          <div class="dw__style-name">${t('style_image_name')}</div>
          <div class="dw__style-sub">${t('style_image_sub')}</div>
        </div>
        ${isImage ? '<div class="dw__style-check">✓</div>' : ''}`;
    }
    if (els.styleImageWrap) els.styleImageWrap.hidden = !isImage;
    if (els.styleImageUpload) {
      renderUploadArea(els.styleImageUpload, els.styleImageClear || null, state.styleImageUrl, {
        icon: '🖼️', titleKey: 'style_image_upload_title', subKey: 'style_image_upload_sub', altText: 'Style reference preview',
      });
    }

    const activeStyle = getStyle();
    const prevKey = els.stylePreviewImg.dataset.previewKey || '';
    let nextKey;
    if (isCustom) nextKey = 'custom';
    else if (isImage) nextKey = 'image:' + (state.styleImageUrl || '');
    else nextKey = 'preset:' + activeStyle.id;
    const changed = nextKey !== prevKey;

    function attachStylePhotoLoader() {
      const img = els.stylePreviewImg.querySelector('img.dw__style-photo');
      if (!img) { els.stylePreviewImg.classList.remove('is-loading'); return; }
      els.stylePreviewImg.classList.add('is-loading');
      const done = () => els.stylePreviewImg.classList.remove('is-loading');
      if (img.complete && img.naturalWidth > 0) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    }

    if (isCustom) {
      els.stylePreviewImg.style.background = '#1a1a2e';
      if (changed) {
        els.stylePreviewImg.innerHTML = `<span class="dw__style-fade" style="font-size:40px;opacity:0.4;">✏️</span><div class="dw__style-placeholder">${t('style_custom_preview_na')}</div>`;
        els.stylePreviewImg.classList.remove('is-loading');
      }
      els.stylePreviewName.innerHTML = t('style_custom_preview_title');
      els.stylePreviewDesc.innerHTML = t('style_custom_preview_desc');
    } else if (isImage) {
      els.stylePreviewImg.style.background = '#1a1a2e';
      if (changed) {
        if (state.styleImageUrl) {
          els.stylePreviewImg.innerHTML = `<img class="dw__style-photo dw__style-fade" src="${state.styleImageUrl}" alt="Style reference" loading="lazy" decoding="async"/>`;
          attachStylePhotoLoader();
        } else {
          els.stylePreviewImg.innerHTML = `<span class="dw__style-fade" style="font-size:40px;opacity:0.4;">🖼️</span><div class="dw__style-placeholder">${t('style_image_preview_na')}</div>`;
          els.stylePreviewImg.classList.remove('is-loading');
        }
      }
      els.stylePreviewName.innerHTML = t('style_image_preview_title');
      els.stylePreviewDesc.innerHTML = t('style_image_preview_desc');
    } else {
      els.stylePreviewImg.style.background = activeStyle.bg;
      const imgUrl = STYLE_IMAGES[activeStyle.id];
      if (changed) {
        const styleName = t('style_' + idKey(activeStyle.id) + '_name') || activeStyle.name;
        if (imgUrl) {
          els.stylePreviewImg.innerHTML = `<img class="dw__style-photo dw__style-fade" src="${imgUrl}" alt="${styleName}" loading="lazy" decoding="async"/>`;
          attachStylePhotoLoader();
        } else {
          const previewSize = ({ round: 180, shield: 140, square: 160 })[state.shape] || 200;
          els.stylePreviewImg.innerHTML = `<div class="dw__style-fade">${signSVG(state.shape, state.style, 'BEWARE OF', state.breed || 'YOUR PET', previewSize)}</div>`;
          els.stylePreviewImg.classList.remove('is-loading');
        }
      }
      els.stylePreviewName.innerHTML = t('style_' + idKey(activeStyle.id) + '_name') || activeStyle.name;
      els.stylePreviewDesc.innerHTML = t('style_' + idKey(activeStyle.id) + '_sub') || activeStyle.sub;
    }
    els.stylePreviewImg.dataset.previewKey = nextKey;
  }

  function renderBevel() {
    els.bevelToggle.classList.toggle('is-on', state.bevel);
    els.bevelNote.hidden = !state.bevel;
    els.bevelCompareItems.forEach((item, i) => {
      const label = item.querySelector('.dw__bevel-compare-label');
      const active = (i === 0) ? !state.bevel : state.bevel;
      item.classList.toggle('dw__bevel-compare-item--active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (label) label.classList.toggle('dw__bevel-compare-label--active', active);
    });
  }

  function renderRecap() {
    const shape = getShape();
    const size = getSize();
    const shapeName = t('shape_' + idKey(shape.id)) || shape.name;
    const sizeLabel = t('size_' + sizeLabelKey(size.id) + '_label') || size.label;
    const backColor = BACK_COLORS.find(c => c.id === state.backColor) || BACK_COLORS[0];
    const colorDot = `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${backColor.hex};border:1px solid rgba(0,0,0,0.15);vertical-align:middle;margin-left:2px;"></span>`;
    // The recap grid is two columns: the customer's selections on the left, and
    // on the right the one thing they cannot see in the preview — that the sign
    // is built to live outdoors and keep its colours.
    els.recap.innerHTML = `
      <div class="dw__recap-card">
        <div class="dw__recap-label">${t('recap_shape_size')} <button type="button" class="dw__recap-edit" data-go-step="0">${t('recap_edit')}</button></div>
        <div class="dw__recap-value">${escapeHtml(shapeName)} · ${escapeHtml(sizeLabel)} - ${colorDot}</div>
        <div class="dw__recap-sub">${escapeHtml(formatDims(shape))}</div>
      </div>
      <div class="dw__recap-card dw__recap-card--outdoor">
        <div class="dw__recap-label">${escapeHtml(t('recap_outdoor_label'))}</div>
        <div class="dw__recap-value">${escapeHtml(t('recap_outdoor_value'))}</div>
        <div class="dw__recap-sub">${escapeHtml(t('recap_uv_note'))}</div>
      </div>`;
    if (els.totalValue) {
      els.totalValue.textContent = formatEur(totalPrice());
    }
  }

  function renderSidebar() {
    const shape = getShape();
    const size = getSize();
    const style = getStyle();
    const shapeName = t('shape_' + idKey(shape.id)) || shape.name;
    const sizeLabel = t('size_' + sizeLabelKey(size.id) + '_label') || size.label;
    const styleName = t('style_' + idKey(style.id) + '_name') || style.name;
    const backColor = BACK_COLORS.find(c => c.id === state.backColor) || BACK_COLORS[0];
    const colorDot = `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${backColor.hex};border:1px solid rgba(0,0,0,0.15);vertical-align:middle;margin-left:2px;"></span>`;
    let subjectSummary = '';
    if (state.petMode === 'upload') {
      if (state.petImageData) subjectSummary = '📸 ' + t('upload_pet_title');
    } else if (state.breed.trim()) {
      const trimmed = state.breed.trim();
      subjectSummary = escapeHtml(trimmed.length > 40 ? trimmed.slice(0, 40) + '…' : trimmed);
    }
    // summaries are pre-escaped HTML — user content is escaped inline, so they can be injected directly
    const summaries = [
      `${escapeHtml(shapeName)} · ${escapeHtml(sizeLabel)} - ${colorDot}`,
      escapeHtml(state.styleMode === 'custom' ? t('step_custom_style') : state.styleMode === 'image' ? t('style_image_name') : styleName),
      subjectSummary,
      state.signText ? '"' + escapeHtml(state.signText.split('\n')[0].slice(0, 24)) + '…"' : '',
    ];
    const labels = STEP_LABELS();
    const titles = STEP_TITLES();
    els.sidebarSteps.innerHTML = labels.map((label, i) => {
      const stepValid = isStepValid(i);
      const isDone = stepValid && (i < state.step || (i === 1 && state.stylePreFilled && i !== state.step));
      const incomplete = !stepValid;
      const status = i === state.step ? 'is-active' : isDone ? 'is-done' : '';
      const incompleteCls = incomplete ? ' is-incomplete' : '';
      const dotIcon = incomplete ? '!' : (isDone ? '✓' : (i + 1));
      const connector = i > 0 ? `<div class="dw__connector ${i <= state.step ? 'is-done' : ''}"></div>` : '';
      const missingTag = incomplete ? `<div class="dw__step-missing">${t('error_step_missing')}</div>` : '';
      return `
        ${connector}
        <button type="button" class="dw__step-nav ${status}${incompleteCls}" data-step-nav="${i}">
          <div class="dw__step-dot">${dotIcon}</div>
          <div class="dw__step-text">
            <div class="dw__step-label">${label}</div>
            <div class="dw__step-title">${titles[i]}</div>
            ${summaries[i] ? `<div class="dw__step-summary">${summaries[i]}</div>` : ''}
            ${missingTag}
          </div>
        </button>`;
    }).join('');

    // On mobile the step strip scrolls horizontally — glide the active step to
    // the centre. Scroll only the strip container (not the page) and animate it
    // so the labels stay legible instead of snapping abruptly.
    const activeNav = els.sidebarSteps.querySelector('.dw__step-nav.is-active');
    const scroller = els.sidebarSteps.parentElement;
    if (activeNav && scroller && scroller.scrollWidth > scroller.clientWidth + 1) {
      const navRect = activeNav.getBoundingClientRect();
      const scRect = scroller.getBoundingClientRect();
      const delta = (navRect.left + navRect.width / 2) - (scRect.left + scRect.width / 2);
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const target = Math.max(0, Math.min(scroller.scrollLeft + delta, maxScroll));
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  function renderPriceBox() {
    const shape = getShape();
    const size = getSize();
    const shapeName = t('shape_' + idKey(shape.id)) || shape.name;
    const sizeLabel = t('size_' + sizeLabelKey(size.id) + '_label') || size.label;
    const backColor = BACK_COLORS.find(c => c.id === state.backColor) || BACK_COLORS[0];
    const colorDot = `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${backColor.hex};border:1px solid rgba(0,0,0,0.15);vertical-align:middle;margin-left:2px;"></span>`;
    const productTotal = totalPrice();
    els.priceValue.textContent = formatEur(productTotal);
    const rows = [];
    rows.push(`<div class="dw__price-row"><span class="dw__price-row-label">${escapeHtml(shapeName)} · ${escapeHtml(sizeLabel)} - ${colorDot}</span><span class="dw__price-row-val">€${basePrice()}</span></div>`);
    rows.push(`<div class="dw__price-row is-total"><span class="dw__price-row-label">${t('price_total')}</span><span class="dw__price-row-val">${formatEur(productTotal)}</span></div>`);
    els.priceRows.innerHTML = rows.join('');
    renderShippingNudges();
  }

  function shippingGap() {
    return Math.max(0, FREE_SHIPPING_THRESHOLD - totalPrice());
  }

  function shippingProgressPct() {
    return Math.min(100, Math.round((totalPrice() / FREE_SHIPPING_THRESHOLD) * 100));
  }

  function shippingNudgeMessage() {
    const gap = formatEurPlain(shippingGap());
    return t('shipping_below_threshold').replace(/\{\{\s*gap\s*\}\}/g, gap);
  }

  function shippingNudgeMarkup(compact) {
    const gap = shippingGap();
    const compactClass = compact ? ' dw__ship-nudge--compact' : '';
    if (gap <= 0) {
      return `<div class="dw__ship-nudge dw__ship-nudge--reached${compactClass}" role="status">${SHIP_CHECK_SVG}<span class="dw__ship-nudge-text">${escapeHtml(t('shipping_reached'))}</span></div>`;
    }
    const pct = shippingProgressPct();
    return `<div class="dw__ship-nudge${compactClass}" role="status">${SHIP_TRUCK_SVG}<div class="dw__ship-nudge-body"><span class="dw__ship-nudge-text">${escapeHtml(shippingNudgeMessage())}</span><div class="dw__ship-nudge-track" aria-hidden="true"><div class="dw__ship-nudge-fill" style="width:${pct}%"></div></div></div></div>`;
  }

  function renderShippingNudges() {
    const gap = shippingGap();
    const markup = shippingNudgeMarkup(false);
    const compactMarkup = shippingNudgeMarkup(true);

    if (els.shippingNudgeTotal) {
      els.shippingNudgeTotal.innerHTML = markup;
      els.shippingNudgeTotal.hidden = false;
    }
    if (els.shippingNudgeFooter) {
      if (gap > 0) {
        els.shippingNudgeFooter.innerHTML = compactMarkup;
        els.shippingNudgeFooter.hidden = false;
      } else {
        els.shippingNudgeFooter.innerHTML = '';
        els.shippingNudgeFooter.hidden = true;
      }
    }
  }

  function renderFooter() {
    els.btnPrev.style.visibility = state.step === 0 ? 'hidden' : 'visible';
    const stepOk = isStepValid(state.step);
    const allOk = isAllValid();
    if (state.step < 3) {
      els.btnNext.classList.remove('is-cta');
      els.btnNext.textContent = t('nav_continue');
      els.btnNext.classList.toggle('is-blocked', !stepOk);
    } else {
      els.btnNext.classList.add('is-cta');
      const isMobile = window.innerWidth <= 749;
      // The button names its own next action, and adding to cart is open to
      // everyone — signed in or not. The only thing that ever holds it back is
      // the design itself: incomplete, or no preview generated yet.
      const addKey = (isMobile && i18n.nav_add_to_cart_mobile) ? 'nav_add_to_cart_mobile' : 'nav_add_to_cart';
      const addLabel = t(addKey);
      const grandTotal = formatEurPlain(totalPrice());
      els.btnNext.textContent = addLabel
        .replace('{{ price }}', grandTotal)
        .replace('{{price}}', grandTotal);
      els.btnNext.classList.toggle('is-blocked', !allOk || !state.previewUrl);
    }
    els.dots.innerHTML = STEP_LABELS().map((_, i) => {
      const isDone = i < state.step || (i === 1 && state.stylePreFilled && i !== state.step);
      const cls = i === state.step ? 'is-active' : isDone ? 'is-done' : '';
      return `<div class="dw__dot ${cls}"></div>`;
    }).join('');
  }

  function renderPanes() {
    els.panes.forEach(pane => {
      pane.hidden = Number(pane.dataset.dwStep) !== state.step;
    });
    const stepOfTpl = t('topbar_step_of');
    els.breadcrumbStep.textContent = stepOfTpl
      .replace('{{ current }}', state.step + 1).replace('{{current}}', state.step + 1)
      .replace('{{ total }}', 4).replace('{{total}}', 4);
  }

  // ── Preview generation ───────────────────────────────────────────────────
  // Prompt construction lives server-side (apps.proxy.preview); the browser
  // only sends a validated config object so storefront JS cannot influence
  // the Gemini prompt directly.

  function normaliseSignText(raw) {
    return String(raw || '').split('\n').map(l => l.trim()).filter(Boolean).join('\n');
  }

  function previewSignature() {
    let styleDesc;
    if (state.styleMode === 'custom') styleDesc = 'custom:' + state.customStyle;
    else if (state.styleMode === 'image') styleDesc = 'image:' + (state.styleImageData ? state.styleImageData.length : 0);
    else styleDesc = state.style;
    const petImg = state.petImageData ? 'pet:' + state.petImageData.length : 'pet:0';
    return [
      state.shape, state.size, state.backColor, state.petMode, state.breed, state.personality,
      styleDesc, 'desc:' + state.bgDescription, petImg, state.signText, state.textStyle, state.bevel ? '1' : '0',
    ].join('|');
  }

  // A regenerate click with an identical signature would burn a generation on
  // the same prompt — Gemini would only return a different random seed of the
  // exact same brief. We block it and tell the customer to tweak something.
  function isPreviewUnchanged() {
    return !!state.previewUrl && !state.previewError && state.previewSignature === previewSignature();
  }

  function scrollIntoViewSoftly(el) {
    if (!el || el.hidden) return;
    try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch { el.scrollIntoView(); }
  }

  function showLoginGate() {
    track('pw_wizard_login_gate', { generations_used: state.freeGenerationsUsed });
    renderAll();
    if (els.loginGate) {
      els.loginGate.classList.remove('is-pulsing');
      // Re-trigger the attention animation on every blocked click.
      void els.loginGate.offsetWidth;
      els.loginGate.classList.add('is-pulsing');
      scrollIntoViewSoftly(els.loginGate);
    }
  }

  // ── Is the visitor signed in yet? ────────────────────────────────────────
  // Liquid stamps `customer` into this page's markup once, when the page is
  // built — and with new customer accounts that snapshot is routinely wrong on
  // the way back from a sign-in. Auth happens on a separate domain and finishes
  // through /customer_authentication/callback; the storefront session is not
  // always readable by the time return_to lands the customer back here, so
  // `{% if customer %}` renders false and the gate is still up on a customer who
  // just signed in. A manual refresh fixes it — which is precisely the tell that
  // the markup, not the session, is what's stale.
  //
  // The same staleness covers the other ways this page misses a sign-in: the
  // login email's button opens wherever the mail app sends it, so the session
  // can be established in a different tab of this browser and never reach the
  // tab that started.
  //
  // Both are one question — "who is the visitor *now*?" — so ask the server
  // that, and reload when the answer disagrees with the markup. Every selection
  // lives in localStorage, so the reload costs the customer nothing, and it is
  // the fresh Liquid render that finally clears the gate.
  const CUSTOMER_STATE_URL = window.location.pathname + '?section_id=customer-state';
  const LOGIN_CHECK_THROTTLE_MS = 4000;
  // Coming back from the callback the session can take a moment to become
  // readable, so one probe is not enough to conclude "still logged out" — these
  // retries cover the lag without the customer touching anything.
  const LOGIN_RETURN_RETRY_MS = [0, 1000, 2500, 5000, 9000];
  // A reload that comes back still logged out would ask again and reload again,
  // so the reloads are counted and capped per tab. One is not enough: the
  // reloaded page can be served from cache, or render a beat before the session
  // is readable, and a single stale answer would then leave the gate up on a
  // customer who *is* signed in with nothing left that would ever re-check.
  // Two bounds the loop just as firmly and survives that one stale render.
  const LOGIN_RELOAD_KEY = 'pw_login_recheck_reloaded';
  const LOGIN_RELOAD_MAX = 2;
  let loginCheckInFlight = false;
  let loginCheckedAt = 0;

  function loginReloadCount() {
    // Older tabs stored the flag as '1'; that parses to one reload spent.
    try { return parseInt(sessionStorage.getItem(LOGIN_RELOAD_KEY) || '0', 10) || 0; } catch { return 0; }
  }

  function noteLoginReload() {
    try { sessionStorage.setItem(LOGIN_RELOAD_KEY, String(loginReloadCount() + 1)); } catch {}
  }

  function alreadyReloadedForLogin() {
    return loginReloadCount() >= LOGIN_RELOAD_MAX;
  }

  // force skips the throttle — the post-callback retries are deliberate, not the
  // incidental repeats the throttle exists to swallow.
  function recheckLoginState(force) {
    if (CUSTOMER_LOGGED_IN) return;
    // Only worth asking where a gate is actually in the customer's way: out of
    // free previews, or standing on step 4 where the cart gate is up. Anywhere
    // else a logged-out visitor is not being stopped by anything, so probing
    // the server on every tab focus would buy nothing.
    if (!needsLogin() && state.step !== 3) return;
    // The free preview is now spent before the request goes out, so the gate is
    // already "in the way" while a generation is still running. Probing there
    // risks answering mid-flight and reloading the page out from under an image
    // the customer is waiting for; the next focus (and the render that closes
    // the generation) asks again a moment later.
    if (state.generating) return;
    if (document.visibilityState === 'hidden') return;
    if (loginCheckInFlight || alreadyReloadedForLogin()) return;
    const now = Date.now();
    if (!force && now - loginCheckedAt < LOGIN_CHECK_THROTTLE_MS) return;
    loginCheckedAt = now;
    loginCheckInFlight = true;
    // no-store: Shopify sends the section back without cache headers, and a
    // heuristically cached logged-out answer would defeat the whole check.
    fetch(CUSTOMER_STATE_URL, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' },
    })
      .then(res => (res.ok ? res.text() : ''))
      .then(html => {
        if (html.indexOf('data-customer-logged-in="1"') < 0) return;
        track('pw_wizard_login_gate_detected', { generations_used: state.freeGenerationsUsed });
        if (saveStateTimer) clearTimeout(saveStateTimer);
        saveState();
        // The reloaded page should still land the customer where they left off,
        // so carry the intent through rather than dropping it — this reload is
        // a step *inside* the sign-in journey, not the end of one.
        markLoginPending(loginIntent());
        noteLoginReload();
        window.location.reload();
      })
      .catch(() => {})
      .finally(() => { loginCheckInFlight = false; });
  }

  // Landed back here from the sign-in flow. Whether the session was simply not
  // readable yet or the customer finished in another tab, the answer arrives
  // within a few seconds — so ask a handful of times and stop.
  function pollForLoginAfterReturn() {
    for (const delay of LOGIN_RETURN_RETRY_MS) {
      setTimeout(() => recheckLoginState(true), delay);
    }
  }

  // Downscale reference images to keep multimodal payloads small.
  // The model only needs ~1024px references; phone photos can be 5MB+ raw.
  function resizeImageToJpegBase64(img, maxDim) {
    const longest = Math.max(img.width, img.height);
    const scale = longest > maxDim ? maxDim / longest : 1;
    const w = Math.max(1, Math.round(img.width * scale));
    const h = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);
    const dataUrl = canvas.toDataURL('image/jpeg', 0.85);
    const comma = dataUrl.indexOf(',');
    return {
      data: comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl,
      mimeType: 'image/jpeg',
    };
  }

  function readImageAsResizedBase64(file, maxDim) {
    return new Promise((resolve, reject) => {
      const objectUrl = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        resolve({ ...resizeImageToJpegBase64(img, maxDim), objectUrl });
      };
      img.onerror = (e) => {
        URL.revokeObjectURL(objectUrl);
        reject(e);
      };
      img.src = objectUrl;
    });
  }

  function renderSignTextError() {
    const errs = visibleErrors(3);
    els.signTextInput.classList.toggle('is-invalid', !!errs.signText);
    const el = root.querySelector('[data-dw-sign-text-error]');
    if (el) el.innerHTML = errorMsg(errs.signText);
  }

  function renderPreview() {
    const hasUrl = !!state.previewUrl;
    // The preview on screen still matches the current selections: a regenerate
    // is a pure no-op, so the button is hard-disabled.
    const unchanged = isPreviewUnchanged() && !state.generating;
    // No matching preview on screen, but this exact brief was already generated
    // earlier today — the image just didn't survive a reload, common in in-app
    // browsers that drop localStorage across the /cart round trip (see
    // rememberGeneratedSig). Same notice, but the button stays live: the confirm
    // in generatePreview is the gate, so the customer is never stranded with no
    // image and no way forward.
    const alreadyMade = !unchanged && !state.generating
      && sigAlreadyGenerated(previewSignature());
    const stale = hasUrl && !state.generating && !unchanged && !alreadyMade
      && state.previewSignature !== previewSignature();
    const regenerating = state.generating && hasUrl;
    const allOk = isAllValid();
    const hasError = !!state.previewError;

    els.previewPlaceholder.hidden = hasUrl || state.generating || hasError;
    els.previewLoading.hidden = !state.generating;
    els.previewLoading.classList.toggle('is-overlay', regenerating);
    els.previewError.hidden = !hasError || state.generating;
    if (hasError) {
      els.previewError.querySelector('[data-dw-error-msg]').textContent =
        typeof state.previewError === 'string' ? state.previewError : t('preview_error_api');
    }
    els.previewImg.hidden = !hasUrl;
    els.previewImg.classList.toggle('is-generating', state.generating);
    if (hasUrl) {
      els.previewImg.src = state.previewUrl;
      // Shape clip CSS is keyed off this attribute (see design-wizard.css).
      els.previewImg.dataset.dwShape = state.previewShape || '';
    }
    if (els.debugRaw && els.debugRawImg) {
      const hasRaw = hasUrl && !state.generating;
      els.debugRaw.hidden = !hasRaw;
      if (hasRaw) els.debugRawImg.src = state.previewUrl;
    }
    if (els.debugPrompt && els.debugPromptText) {
      const hasPrompt = !!state.previewPrompt && !state.generating;
      els.debugPrompt.hidden = !hasPrompt;
      if (hasPrompt && els.debugPromptText.textContent !== state.previewPrompt) {
        els.debugPromptText.textContent = state.previewPrompt;
        els.debugPrompt.open = false;
      }
    }

    const limitReached = state.generationsUsed >= GENERATION_LIMIT;
    const gated = needsLogin() && !state.generating;
    // Regenerating an identical brief is a no-op that would burn a generation,
    // so the button is disabled until something in the details actually changes
    // — the notice below it says exactly that. The account gate takes priority:
    // while it's up, it's the one thing the customer needs to act on.
    // (`unchanged` / `alreadyMade` are computed at the top of this function.)
    if (els.previewUnchanged) {
      els.previewUnchanged.hidden = !((unchanged || alreadyMade) && allOk && !limitReached && !gated);
    }
    if (els.loginGate) {
      els.loginGate.hidden = !gated;
    }

    // The button reads "Sign in to continue" only when signing in genuinely is
    // the next action (the label chain below picks the incomplete design and
    // the spent daily allowance first). That is exactly when it must look like
    // a live CTA: `is-blocked` greys it to 55% with a not-allowed cursor, which
    // on a button that says "sign in" reads as "this is broken" — and the
    // identical-brief `unchanged` block must not grey it either, since the tap
    // leaves for the login page rather than spending a generation.
    const gateCta = gated && allOk && !limitReached;
    els.btnGenerate.disabled = state.generating || !allOk || limitReached || (unchanged && !gated);
    els.btnGenerate.classList.toggle('is-stale', stale && allOk && !limitReached && !gated);
    els.btnGenerate.classList.toggle('is-blocked', (!allOk || limitReached || unchanged) && !gateCta && !state.generating);
    els.btnGenerate.classList.toggle('is-generating', state.generating);
    els.btnGenerate.classList.toggle('is-retry', hasError && !state.generating && allOk && !limitReached && !gated);
    const labelText = state.generating
      ? t('preview_generating')
      : limitReached
        ? t('preview_gen_limit_btn')
        : !allOk
          ? t('preview_complete_required')
          : gated
            ? t('preview_login_btn')
            : hasError
              ? t('preview_retry') || t('preview_regenerate')
              : hasUrl
                ? t('preview_regenerate')
                : t('preview_generate');
    if (els.btnGenerateLabel) {
      els.btnGenerateLabel.textContent = labelText;
    } else {
      els.btnGenerate.textContent = labelText;
    }
    els.previewStale.hidden = !stale || !allOk || limitReached;

    renderRating(hasUrl && !stale && !regenerating && !hasError);
    renderGenMeter();
  }

  // ── Preview rating ───────────────────────────────────────────────────────
  // 👍/👎 under the finished image, then reason chips + an optional comment.
  // Two beats on purpose: the thumb is sent the moment it's tapped, so the
  // signal survives someone who never opens the second step, and the chips
  // then send again over the top. Two POSTs for one image is the expected
  // shape — the server logs both and the audit page keeps the latest.
  //
  // Keep RATING_REASONS in sync with VALID_RATING_REASONS in
  // cloud-run/src/rating.ts: an id the server doesn't know is dropped silently.
  const RATING_REASONS = ['breed', 'sign_text', 'colors', 'style', 'background', 'quality'];

  function resetRating() {
    state.ratingFor = null;
    state.ratingVerdict = null;
    state.ratingReasons = [];
    state.ratingComment = '';
    state.ratingDetailsOpen = false;
    state.ratingSent = false;
    if (els.ratingComment) els.ratingComment.value = '';
    els.ratingReasons.forEach((box) => { box.checked = false; });
  }

  function renderRating(visible) {
    if (!els.rating) return;
    // The rating is pinned to one image: a stale or regenerating preview isn't
    // the thing on screen any more, and an unrated older preview restored from
    // localStorage still deserves the prompt.
    const ratedThis = !!state.ratingVerdict && state.ratingFor === state.previewUrl;
    els.rating.hidden = !visible;
    if (!visible) return;

    if (els.ratingUp) els.ratingUp.setAttribute('aria-pressed', String(ratedThis && state.ratingVerdict === 'up'));
    if (els.ratingDown) els.ratingDown.setAttribute('aria-pressed', String(ratedThis && state.ratingVerdict === 'down'));

    const showDetails = ratedThis && state.ratingDetailsOpen;
    if (els.ratingDetails) els.ratingDetails.hidden = !showDetails;
    // The follow-up asks the question the thumb implies: after 👍 what worked,
    // after 👎 what didn't. Same six ids either way — they name an aspect of
    // the design, not a complaint — so the server list never has to change,
    // and the verdict logged beside them says which way to read them.
    if (showDetails) {
      const up = state.ratingVerdict === 'up';
      if (els.ratingReasonsLegend) {
        els.ratingReasonsLegend.textContent = up ? t('rating_reasons_up') : t('rating_reasons_down');
      }
      els.ratingReasonLabels.forEach((label) => {
        const text = label.getAttribute(up ? 'data-label-up' : 'data-label-down');
        if (text) label.textContent = text;
      });
      if (els.ratingComment) {
        const ph = els.ratingComment.getAttribute(up ? 'data-placeholder-up' : 'data-placeholder-down');
        if (ph) els.ratingComment.placeholder = ph;
      }
    }
    if (els.ratingThanks) els.ratingThanks.hidden = !(ratedThis && !state.ratingDetailsOpen);
  }

  function sendRating(includePhotos) {
    if (!/^https:\/\//.test(state.previewUrl || '') || !state.ratingVerdict) return;
    // keepalive: the customer may hit "add to cart" a moment later, and this
    // must not be cancelled by the navigation — same reason as cart-add below.
    fetch(RATING_ENDPOINT, {
      method: 'POST',
      keepalive: true,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        previewUrl: state.previewUrl,
        verdict: state.ratingVerdict,
        reasons: state.ratingReasons,
        comment: state.ratingComment,
        shape: state.previewShape || state.shape,
        size: state.size,
        style: state.style,
        styleMode: state.styleMode,
        generationNumber: state.generationsUsed,
        locale: LOCALE,
      }),
    }).catch(() => {});
    state.ratingSent = true;

    // A 👎 is the only verdict worth keeping the customer's reference photo
    // for, and a base64 photo is too big for a keepalive fetch (Chromium caps
    // those around 64KB) — so it's a separate, best-effort, non-keepalive
    // request the rating itself never depends on. Fired once, from the tap
    // that first sets the verdict, not again when reasons/comment follow.
    //
    // Only the photos this generation actually used: the wizard keeps an
    // uploaded image in state after the customer switches back to "Describe"
    // or to a preset style, and /preview never sends it then — so without this
    // gate a 👎 on a Pixar preset archived a style image the prompt never saw,
    // and the audit page showed both.
    const usedPetImage   = state.petMode === 'upload' ? state.petImageData : null;
    const usedStyleImage = state.styleMode === 'image' ? state.styleImageData : null;
    if (includePhotos && state.ratingVerdict === 'down' && (usedPetImage || usedStyleImage)) {
      fetch(RATING_ENDPOINT, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          previewUrl: state.previewUrl,
          verdict: state.ratingVerdict,
          referencePhotos: true,
          petImage: usedPetImage ? { data: usedPetImage, mimeType: state.petImageMime } : undefined,
          styleImage: usedStyleImage ? { data: usedStyleImage, mimeType: state.styleImageMime } : undefined,
        }),
      }).catch(() => {});
    }
  }

  function rateVerdict(verdict) {
    if (!state.previewUrl) return;
    // Tapping the same thumb again closes the follow-up rather than re-sending.
    const same = state.ratingFor === state.previewUrl && state.ratingVerdict === verdict;
    if (same) {
      state.ratingDetailsOpen = !state.ratingDetailsOpen;
      renderRating(true);
      return;
    }
    state.ratingFor = state.previewUrl;
    state.ratingVerdict = verdict;
    state.ratingReasons = [];
    state.ratingComment = '';
    state.ratingDetailsOpen = true;
    if (els.ratingComment) els.ratingComment.value = '';
    els.ratingReasons.forEach((box) => { box.checked = false; });
    sendRating(true);
    track('pw_wizard_rating', { verdict, shape: state.previewShape || state.shape, style: state.style });
    renderRating(true);
    scheduleSave();
  }

  function submitRatingDetails() {
    if (!state.ratingVerdict) return;
    state.ratingReasons = [...els.ratingReasons].filter((b) => b.checked).map((b) => b.value)
      .filter((id) => RATING_REASONS.includes(id));
    state.ratingComment = (els.ratingComment ? els.ratingComment.value : '').trim().slice(0, 500);
    state.ratingDetailsOpen = false;
    sendRating();
    track('pw_wizard_rating_details', {
      verdict: state.ratingVerdict,
      reasons: state.ratingReasons.join(','),
      has_comment: !!state.ratingComment,
    });
    renderRating(true);
    scheduleSave();
  }

  // ── Daily generation meter ───────────────────────────────────────────────
  // Big "N/5" counter + one dot per generation, so the remaining allowance and
  // the fact that it's a *daily* one are readable at a glance.
  function renderGenDots(remaining) {
    if (!els.genDots) return;
    if (els.genDots.childElementCount !== GENERATION_LIMIT) {
      els.genDots.textContent = '';
      for (let i = 0; i < GENERATION_LIMIT; i++) {
        const dot = document.createElement('span');
        dot.className = 'dw__gen-meter-dot';
        els.genDots.appendChild(dot);
      }
    }
    Array.prototype.forEach.call(els.genDots.children, (dot, i) => {
      dot.classList.toggle('is-used', i >= remaining);
    });
  }

  function renderGenMeter() {
    if (!els.genLimit) return;
    const remaining = Math.max(0, GENERATION_LIMIT - state.generationsUsed);
    els.genLimit.hidden = false;
    els.genLimit.classList.toggle('is-exhausted', remaining === 0);
    els.genLimit.classList.toggle('is-low', remaining > 0 && remaining <= 2);
    if (els.genCount) els.genCount.textContent = String(remaining);
    if (els.genTotal) els.genTotal.textContent = '/' + GENERATION_LIMIT;
    if (els.genLabel) {
      els.genLabel.textContent = remaining === 0
        ? t('preview_gen_limit_reached')
        : remaining === 1
          ? t('preview_gen_left_one')
          : t('preview_gen_left');
    }
    // The 5-a-day budget is the same for everyone, but a logged-out visitor is
    // stopped by the account gate after FREE_GENERATIONS — so the plain "you get
    // 5 free previews a day" note would read as a broken promise on their second
    // click. Guests get a note that states the gate up front instead.
    const resetNote = CUSTOMER_LOGGED_IN ? 'preview_gen_reset_note' : 'preview_gen_reset_note_guest';
    if (els.genNote) els.genNote.textContent = t(resetNote);
    renderGenDots(remaining);
    // Screen readers get the plain sentence rather than the "5/5" fragment.
    els.genLimit.setAttribute('aria-label', remaining === 0
      ? t('preview_gen_limit_reached') + ' ' + t(resetNote)
      : t('preview_gen_remaining').replace('%count%', String(remaining)));
  }

  // ── Generation progress timer ────────────────────────────────────────────
  function setProgressText(remainingSec, finalising) {
    if (!els.progressTime) return;
    els.progressTime.classList.toggle('is-finalising', !!finalising);
    if (finalising) {
      els.progressTime.textContent = t('preview_timer_finalising');
      return;
    }
    els.progressTime.textContent = String(remainingSec);
  }

  function startGenerateTimer() {
    stopGenerateTimer();
    const start = Date.now();
    if (els.progressFill) {
      els.progressFill.classList.remove('is-finalising');
      els.progressFill.style.transition = 'none';
      els.progressFill.style.strokeDashoffset = RING_CIRCUMFERENCE;
      void els.progressFill.getBoundingClientRect();
      els.progressFill.style.transition = 'stroke-dashoffset ' + TIMER_TOTAL_MS + 'ms linear';
      els.progressFill.style.strokeDashoffset = '0';
    }
    setProgressText(Math.ceil(TIMER_TOTAL_MS / 1000), false);
    state.timerInterval = setInterval(() => {
      const elapsed = Date.now() - start;
      if (elapsed >= TIMER_TOTAL_MS) {
        if (els.progressFill) els.progressFill.classList.add('is-finalising');
        setProgressText(0, true);
      } else {
        setProgressText(Math.max(1, Math.ceil((TIMER_TOTAL_MS - elapsed) / 1000)), false);
      }
    }, 250);
  }

  function stopGenerateTimer() {
    if (state.timerInterval) {
      clearInterval(state.timerInterval);
      state.timerInterval = null;
    }
    if (els.progressFill) {
      els.progressFill.classList.remove('is-finalising');
      els.progressFill.style.transition = 'stroke-dashoffset 0.25s ease-out';
      els.progressFill.style.strokeDashoffset = RING_CIRCUMFERENCE;
    }
  }

  async function generatePreview() {
    if (state.generating) return;
    if (needsLogin()) {
      showLoginGate();
      return;
    }
    // Defensive: the button is already disabled in this state (see renderPreview).
    if (isPreviewUnchanged()) {
      renderAll();
      return;
    }
    // The preview itself is gone (e.g. localStorage dropped on the way back from
    // the cart in an in-app browser) so the button isn't disabled — but this
    // exact brief was already generated today. Regenerating only rerolls the
    // same prompt; say so and let the customer decide.
    if (sigAlreadyGenerated(previewSignature())
        && typeof window.confirm === 'function'
        && !window.confirm(t('preview_confirm_same'))) {
      track('pw_wizard_generate_same_declined', {});
      return;
    }
    if (state.generationsUsed >= GENERATION_LIMIT) {
      state.previewError = t('preview_gen_limit_reached');
      renderAll();
      return;
    }
    state.generating = true;
    state.previewError = false;
    const sigAtStart = previewSignature();
    const shapeAtStart = state.shape;
    state.generationsUsed = state.generationsUsed + 1;
    setGenUsage(state.generationsUsed);
    // The anonymous free preview is spent up front too, and refunded below only
    // if the server comes back saying it produced nothing. Burning it on success
    // alone leaked previews: the increment used to sit after the response, so a
    // tab closed (or a connection dropped) during the ~30s generation left the
    // server having rendered a Lite preview with this counter still at zero —
    // the visitor returned to an open gate and took a second free one. That is
    // the `lite · #2` row in the admin audit log.
    if (!CUSTOMER_LOGGED_IN) {
      state.freeGenerationsUsed = state.freeGenerationsUsed + 1;
      setFreeGenCount(state.freeGenerationsUsed);
    }
    // Whether the server ever answered this request — the difference between
    // "it told us it generated nothing" (refundable) and "we never found out"
    // (not refundable: it may well have generated).
    let serverAnswered = false;
    track('pw_wizard_generate', {
      shape: state.shape, size: state.size, style: state.style,
      style_mode: state.styleMode, bevel: !!state.bevel,
      generation_number: state.generationsUsed,
    });
    startGenerateTimer();
    renderAll();

    try {
      const body = {
        shape:         state.shape,
        size:          state.size,
        backColor:     state.backColor,
        breed:         state.breed,
        personality:   state.personality,
        style:         state.style,
        styleMode:     state.styleMode,
        customStyle:   state.customStyle,
        signText:      normaliseSignText(state.signText),
        textStyle:     state.textStyle.trim(),
        bevel:         state.bevel,
        bgDescription: state.bgDescription,
        // Which preview of the day this is (already incremented above, so the
        // first one sends 1). Audit log only — model routing is login-based
        // (logged-in → full Nano Banana 2, anonymous → Lite; see pickImageModel).
        generationNumber: state.generationsUsed,
        // Logged server-side (Cloud Logging generation audit). Sent in the body
        // because App Proxy / edge may rewrite the User-Agent header — and the
        // IP the server sees is Shopify's App Proxy, never the visitor's, so
        // the origin signals have to travel the same way.
        userAgent:     typeof navigator !== 'undefined' ? navigator.userAgent : '',
        ...originFields(),
      };
      // Identity for the server-side Klaviyo "Generated Sign Preview" event
      // (see cloud-run/src/klaviyo.ts) — only present for logged-in customers,
      // same gate the old client-side tracking used.
      if (CUSTOMER_LOGGED_IN && CUSTOMER_EMAIL) {
        body.email = CUSTOMER_EMAIL;
        if (CUSTOMER_FIRST_NAME) body.firstName = CUSTOMER_FIRST_NAME;
        body.locale = LOCALE;
        body.productURL = window.location.origin + window.location.pathname;
      }
      if (state.petMode === 'upload' && state.petImageData) {
        body.petImage = { data: state.petImageData, mimeType: state.petImageMime };
      }
      if (state.styleMode === 'image' && state.styleImageData) {
        body.styleImage = { data: state.styleImageData, mimeType: state.styleImageMime };
      }
      const res = await fetch(PREVIEW_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      serverAnswered = true;
      // The daily-generation counter is a client-side budget persisted in
      // localStorage. We deliberately ignore any `remainingGenerations` field
      // from the server — Cloud Run runs ephemeral instances, so a server
      // counter would reset on cold-start/scale and falsely "refill" the
      // user's quota. Local-only is consistent across instances, and the
      // counter is only a soft UX nudge anyway.
      let parsed = null;
      try { parsed = await res.json(); } catch {}
      if (res.status === 429) {
        state.generationsUsed = GENERATION_LIMIT;
        setGenUsage(GENERATION_LIMIT);
        throw new Error('rate_limited');
      }
      // 422 + code=content_blocked → Gemini's content filter rejected the
      // prompt. Surface it with a distinct code so the catch below can show
      // an actionable message instead of the generic API error.
      if (res.status === 422 && parsed && parsed.code === 'content_blocked') {
        throw new Error('content_blocked');
      }
      if (!res.ok) throw new Error('API ' + res.status);
      if (!parsed || !parsed.previewUrl) throw new Error('No image in response');
      // The server already uploaded the image to GCS and handed us the URL —
      // no client-side upload at add-to-cart, and the round shape is clipped
      // for display via CSS (see design-wizard.css).
      state.previewUrl = parsed.previewUrl;
      state.previewShape = parsed.shape || shapeAtStart;
      state.previewPrompt = parsed.prompt || null;
      state.previewSignature = sigAtStart;
      // Redundant tiny record so the "nothing changed" notice still fires if the
      // full snapshot doesn't survive the next reload (see rememberGeneratedSig).
      rememberGeneratedSig(sigAtStart);
      // A rating belongs to the image it was left on, never to the next one.
      resetRating();
      track('pw_wizard_generate_success', { shape: shapeAtStart, generation_number: state.generationsUsed });
      // Klaviyo's "Generated Sign Preview" event is now sent server-side by
      // Cloud Run (cloud-run/src/klaviyo.ts) from the same /preview response
      // this call already produced — see docs/klaviyo/README.md for why this
      // moved off the browser (ad blockers silently dropped the old
      // client-side window.klaviyo calls with no error).
    } catch (err) {
      console.error('[design-wizard] preview generation failed', err);
      const errStr = String(err);
      const rateLimited = /rate_limited/.test(errStr);
      track('pw_wizard_generate_error', {
        reason: rateLimited ? 'rate_limited'
          : /content_blocked/.test(errStr) ? 'content_blocked'
          : /networkerror|failed to fetch/i.test(errStr) ? 'network'
          : 'api',
      });
      if (!rateLimited) {
        state.generationsUsed = Math.max(0, state.generationsUsed - 1);
        setGenUsage(state.generationsUsed);
      }
      // A failed attempt must not send the customer to the login page
      // empty-handed — but only when we know they got nothing. An answer means
      // the server told us it produced no image (rate limit, content filter,
      // error status, empty payload), so the preview goes back. A request that
      // never came back is the ambiguous one, and it stays spent: refunding it
      // is exactly what handed out the second free Lite preview.
      if (!CUSTOMER_LOGGED_IN && serverAnswered) {
        state.freeGenerationsUsed = Math.max(0, state.freeGenerationsUsed - 1);
        setFreeGenCount(state.freeGenerationsUsed);
      }
      state.previewError = /networkerror|failed to fetch/i.test(errStr)
        ? t('preview_error_network')
        : rateLimited
          ? t('preview_gen_limit_reached')
          : /content_blocked/.test(errStr)
            ? t('preview_error_content_blocked')
            : t('preview_error_api');
    } finally {
      state.generating = false;
      stopGenerateTimer();
      renderAll();
      scheduleSave();
    }
  }

  // Every free-text field is clamped server-side (pickString in validate.ts),
  // so the inputs carry a matching maxlength. A counter appears once the
  // customer gets close to it — otherwise the browser just stops accepting
  // keystrokes with no explanation.
  const charCounters = [];
  function initCharCounters() {
    root.querySelectorAll('.dw__textarea[maxlength], .dw__input[maxlength]').forEach(field => {
      const max = parseInt(field.getAttribute('maxlength'), 10);
      if (!max) return;
      const el = document.createElement('div');
      el.className = 'dw__count';
      el.hidden = true;
      field.insertAdjacentElement('afterend', el);
      const update = () => {
        const len = field.value.length;
        el.textContent = len + '/' + max;
        el.hidden = len < max * 0.75;
        el.classList.toggle('is-full', len >= max);
      };
      field.addEventListener('input', update);
      charCounters.push(update);
    });
  }
  function renderCharCounters() { charCounters.forEach(update => update()); }

  function renderAll() {
    renderCharCounters();
    renderPanes();
    renderSidebar();
    renderPriceBox();
    renderShapes();
    renderSizes();
    renderBackColors();
    renderPetUpload();
    renderPetMode();
    renderBgDescription();
    renderStyles();
    renderBevel();
    renderRecap();
    renderSignTextError();
    renderPreview();
    renderFooter();
  }

  function setStyleMode(mode) {
    state.styleMode = mode;
    renderAll();
  }

  // ── Event wiring ─────────────────────────────────────────────────────────
  function hydrateDeferredImages(stepIndex) {
    const pane = root.querySelector(`[data-dw-step="${stepIndex}"]`);
    if (!pane) return;
    pane.querySelectorAll('img[data-dw-deferred-src]').forEach(img => {
      const src = img.getAttribute('data-dw-deferred-src');
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.removeAttribute('data-dw-deferred-src');
    });
  }

  function goToStep(i) {
    // A tip belongs to the field it was fired from; leaving it behind on a pane
    // the customer has left would just pop back at them on the way in again.
    dismissPresetHint();
    const prev = state.step;
    state.step = Math.max(0, Math.min(3, i));
    if (state.step !== prev) track('pw_wizard_step_view', { step: state.step + 1 });
    // Steps 3 & 4 (pet/scene and preview): pre-warm Cloud Run before Generate.
    if (i === 2 || i === 3) pingWarm();
    hydrateDeferredImages(state.step);
    renderAll();
    if (els.content) els.content.scrollTop = 0;
  }

  function showToast(msg) {
    let toast = document.getElementById('dw-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'dw-toast';
      toast.className = 'dw__toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.remove(), 3000);
  }

  // Sidebar step nav
  els.sidebarSteps.addEventListener('click', e => {
    const btn = e.target.closest('[data-step-nav]');
    if (btn) goToStep(Number(btn.dataset.stepNav));
  });

  // Step 1: shape & size
  els.shapeGrid.addEventListener('click', e => {
    const btn = e.target.closest('[data-shape-id]');
    if (!btn) return;
    state.shape = btn.dataset.shapeId;
    renderAll();
  });
  els.sizeTabs.addEventListener('click', e => {
    const btn = e.target.closest('[data-size-id]');
    if (!btn) return;
    state.size = btn.dataset.sizeId;
    renderAll();
  });
  if (els.backColorTabs) {
    els.backColorTabs.addEventListener('click', e => {
      const btn = e.target.closest('[data-back-color]');
      if (!btn) return;
      state.backColor = btn.dataset.backColor;
      renderAll();
    });
  }

  function wireImageUpload({ trigger, fileInput, clearBtn, urlKey, dataKey, mimeKey }) {
    if (!trigger || !fileInput) return;
    trigger.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', async e => {
      const f = e.target.files && e.target.files[0];
      if (!f) return;
      try {
        const { data, mimeType, objectUrl } = await readImageAsResizedBase64(f, 1280);
        state[urlKey]  = objectUrl;
        state[dataKey] = data;
        state[mimeKey] = mimeType;
      } catch (err) {
        console.error('[design-wizard] image read failed', err);
        state[urlKey]  = URL.createObjectURL(f);
        state[dataKey] = null;
      }
      renderAll();
      scheduleSave();
    });
    if (clearBtn) {
      clearBtn.addEventListener('click', e => {
        e.stopPropagation();
        state[urlKey]  = null;
        state[dataKey] = null;
        fileInput.value = '';
        renderAll();
      });
    }
  }

  // Step 2: style
  els.styleChips.addEventListener('click', e => {
    const btn = e.target.closest('[data-style-id]');
    if (!btn) return;
    state.style = btn.dataset.styleId;
    setStyleMode('preset');
    showPresetHint('style');
  });
  // Already writing their own style — the tip has nothing left to tell them.
  els.styleCustom.addEventListener('click', () => {
    dismissPresetHint();
    setStyleMode('custom');
  });
  const customTextarea = root.querySelector('[data-dw-custom-text]');
  if (customTextarea) {
    customTextarea.addEventListener('input', e => {
      state.customStyle = e.target.value;
      renderAll();
    });
  }

  if (els.styleImage) {
    els.styleImage.addEventListener('click', () => setStyleMode('image'));
  }
  wireImageUpload({
    trigger: els.styleImageUpload, fileInput: els.styleImageInput, clearBtn: els.styleImageClear,
    urlKey: 'styleImageUrl', dataKey: 'styleImageData', mimeKey: 'styleImageMime',
  });

  // Step 3: pet
  wireImageUpload({
    trigger: els.petUpload, fileInput: els.petUploadInput, clearBtn: els.petUploadClear,
    urlKey: 'petImageUrl', dataKey: 'petImageData', mimeKey: 'petImageMime',
  });
  if (els.petModeToggle) {
    const setPetMode = mode => {
      if (mode === state.petMode) return;
      // Only the active mode's value is ever sent, so switching away from a
      // route the customer already filled in quietly drops that work. Say it —
      // otherwise the only signal is a preview that ignores half their input.
      const abandoned = mode === 'upload' ? !!state.breed.trim() : !!state.petImageData;
      state.petMode = mode;
      renderAll();
      if (abandoned) showPresetHint(mode === 'upload' ? 'petModeUpload' : 'petModeDescribe');
    };
    els.petModeToggle.addEventListener('click', e => {
      const btn = e.target.closest('[data-pet-mode]');
      if (!btn) return;
      setPetMode(btn.dataset.petMode);
    });
    // Arrow keys move within a radiogroup — with a roving tabindex, Tab alone
    // can only ever reach the option that is already checked.
    els.petModeToggle.addEventListener('keydown', e => {
      const step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1
        : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      const btns = Array.prototype.slice.call(els.petModeToggle.querySelectorAll('button'));
      const i = btns.findIndex(b => b.dataset.petMode === state.petMode);
      const next = btns[(i + step + btns.length) % btns.length];
      if (!next) return;
      setPetMode(next.dataset.petMode);
      next.focus();
    });
  }
  els.breedInput.addEventListener('input', e => {
    state.breed = e.target.value;
    renderAll();
  });
  els.personalityInput.addEventListener('input', e => {
    state.personality = e.target.value;
    renderAll();
  });
  els.bgDescription.addEventListener('input', e => {
    state.bgDescription = e.target.value;
    renderAll();
  });

  // Step 4: text, bevel, recap
  els.signTextInput.addEventListener('input', e => {
    state.signText = e.target.value;
    renderAll();
  });
  if (els.textStyleInput) {
    els.textStyleInput.addEventListener('input', e => {
      state.textStyle = e.target.value;
      renderAll();
    });
  }

  // ── Preset hint bubbles ──────────────────────────────────────────────────
  // Tapping a preset fills a field with someone else's words, and nothing on
  // screen says those words are only a starting point — the customer who never
  // edits them ends up with the same sign as everyone else who tapped the same
  // chip. So every time a preset is used, a small bubble says it out loud, then
  // dissolves on its own after 8 seconds. Every time, not once per field: a
  // customer who is still tapping presets is exactly the one who hasn't taken
  // the point yet, and the bubble costs them nothing — it never moves the form
  // and it goes away by itself.
  // field → locale key of the tip it fires.
  const PRESET_HINTS = {
    bgDescription: 'preset_hint_bg',
    signText:      'preset_hint_sign_text',
    textStyle:     'preset_hint_text_style',
    style:         'preset_hint_style',
    // Not presets, but the same bubble doing the same job: switching the
    // subject mode with the other route already filled in silently drops that
    // input from the generation, and only this says so.
    petModeUpload:   'pet_mode_hint_upload',
    petModeDescribe: 'pet_mode_hint_describe',
  };
  const PRESET_HINT_VISIBLE_MS = 8000;
  const PRESET_HINT_FADE_MS = 320;

  // Fields whose bubble has no preset chip group to hang off get a slot of
  // their own in the markup.
  const HINT_SLOTS = { style: 'style', petModeUpload: 'petMode', petModeDescribe: 'petMode' };

  function presetHintAnchor(field) {
    const slot = HINT_SLOTS[field];
    return slot
      ? root.querySelector('[data-dw-hint-slot="' + slot + '"]')
      : root.querySelector('[data-dw-chips="' + field + '"]');
  }

  let activePresetHint = null;
  // immediate skips the fade — used when one bubble replaces another, where a
  // ghost fading out under the new one just looks like a rendering glitch.
  function dismissPresetHint(immediate) {
    const hint = activePresetHint;
    if (!hint) return;
    activePresetHint = null;
    clearTimeout(hint._dwHideTimer);
    if (immediate === true) { hint.remove(); return; }
    hint.classList.remove('is-in');
    setTimeout(() => hint.remove(), PRESET_HINT_FADE_MS);
  }

  function showPresetHint(field) {
    const key = PRESET_HINTS[field];
    if (!key) return;
    const anchor = presetHintAnchor(field);
    const message = t(key);
    // A locale without the pawsitive.* namespace renders the key back or a
    // "Translation missing: …" placeholder — either is worse than no tip.
    if (!anchor || !message || message === key || /^translation missing/i.test(message)) return;

    dismissPresetHint(true);

    const hint = document.createElement('div');
    hint.className = 'dw__preset-hint';
    hint.setAttribute('role', 'status');
    hint.innerHTML =
      '<span class="dw__preset-hint-icon" aria-hidden="true">✨</span>' +
      '<span class="dw__preset-hint-text"></span>' +
      '<button type="button" class="dw__preset-hint-close" aria-label="' +
        escapeHtml(t('preset_hint_dismiss')) + '">✕</button>';
    hint.querySelector('.dw__preset-hint-text').textContent = message;
    hint.addEventListener('click', dismissPresetHint);

    anchor.classList.add('dw__hint-anchor');
    anchor.appendChild(hint);
    // Next frame, so the browser has the pre-transition state to animate from.
    requestAnimationFrame(() => hint.classList.add('is-in'));
    hint._dwHideTimer = setTimeout(dismissPresetHint, PRESET_HINT_VISIBLE_MS);
    activePresetHint = hint;
    track('pw_wizard_preset_hint', { field });
  }

  // The customer typing in a field has already got the message; leaving the
  // bubble up would only cover the field hint underneath it.
  root.addEventListener('input', dismissPresetHint, true);

  // Preset chips — one tap drops a ready-made starting point into a free-text
  // field, which the customer is then free to edit. The chip group names the
  // state field it fills, the chip itself carries the value.
  const CHIP_FIELD_INPUTS = {
    bgDescription: els.bgDescription,
    signText:      els.signTextInput,
    textStyle:     els.textStyleInput,
  };
  root.addEventListener('click', e => {
    const btn = e.target.closest('[data-dw-chip]');
    if (!btn) return;
    const group = btn.closest('[data-dw-chips]');
    const field = group && group.dataset.dwChips;
    const fill  = btn.getAttribute('data-fill') || '';
    if (!fill || !Object.prototype.hasOwnProperty.call(CHIP_FIELD_INPUTS, field)) return;
    state[field] = fill;
    const input = CHIP_FIELD_INPUTS[field];
    if (input) input.value = fill;
    renderAll();
    showPresetHint(field);
  });

  els.bevelToggle.addEventListener('click', () => {
    state.bevel = !state.bevel;
    renderAll();
  });

  if (els.ratingUp) els.ratingUp.addEventListener('click', () => rateVerdict('up'));
  if (els.ratingDown) els.ratingDown.addEventListener('click', () => rateVerdict('down'));
  if (els.ratingSubmit) els.ratingSubmit.addEventListener('click', submitRatingDetails);
  els.recap.addEventListener('click', e => {
    const btn = e.target.closest('[data-go-step]');
    if (btn) goToStep(Number(btn.dataset.goStep));
  });
  els.btnGenerate.addEventListener('click', () => {
    if (state.generating) return;
    if (!isAllValid()) {
      [0, 1, 2, 3].forEach(i => { if (!isStepValid(i)) state.showErrors[i] = true; });
      const target = firstInvalidStep();
      if (target !== undefined && target !== state.step) {
        goToStep(target);
      } else {
        renderAll();
      }
      showToast(t('error_complete_required_all'));
      return;
    }
    // Out of free previews: this button now reads "Sign in to continue", so it
    // has to actually do that. Re-pulsing the panel underneath left the most
    // prominent control at the gate saying "sign in" and going nowhere — so
    // send them off, with the lossless return the saved state buys.
    if (needsLogin()) {
      track('pw_wizard_login_gate_click', {
        generations_used: state.freeGenerationsUsed,
        source: 'generate_button',
      });
      goToLogin('preview');
      window.location.href = withReturnUrl(LOGIN_URL);
      return;
    }
    generatePreview();
  });
  // Account gate CTA. The href carries the return path back to this page and
  // the click flushes the pending debounced save, so nothing the customer has
  // already configured is lost while they're off on the account pages.
  if (els.loginGateCta) {
    els.loginGateCta.href = withReturnUrl(LOGIN_URL);
    els.loginGateCta.addEventListener('click', () => {
      goToLogin('preview');
      track('pw_wizard_login_gate_click', {
        generations_used: state.freeGenerationsUsed,
        source: 'gate_panel',
      });
    });
  }

  // Whichever tab of this browser the customer finished signing in from, this
  // one finds out the moment it is looked at again. focus covers a second
  // desktop window (no visibilitychange there) and pageshow covers a back
  // navigation restored from the bfcache, where the markup is as stale as it
  // gets. A sign-in completed in a *different* browser stays out of reach:
  // there is no session cookie to share.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') recheckLoginState();
  });
  window.addEventListener('focus', recheckLoginState);
  window.addEventListener('pageshow', (e) => { if (e.persisted) recheckLoginState(); });

  // Friction against saving the generated design instead of buying it: no
  // right-click / Android long-press "Save image", no drag to the desktop, and
  // (with -webkit-touch-callout in design-wizard.css) no iOS long-press menu.
  // A deterrent, not protection: the image is a public GCS URL the browser has
  // already downloaded, and a screenshot always works.
  const guardImage = (img) => {
    img.draggable = false;
    img.addEventListener('contextmenu', (e) => e.preventDefault());
    img.addEventListener('dragstart', (e) => e.preventDefault());
  };
  guardImage(els.previewImg);

  // Click preview image to open fullscreen lightbox
  const lightbox = (() => {
    const el = document.createElement('div');
    el.id = 'dw-lightbox';
    el.className = 'dw__lightbox';
    el.hidden = true;
    el.innerHTML = `
      <button type="button" class="dw__lightbox-close" aria-label="Close">✕</button>
      <img class="dw__lightbox-img" alt="" decoding="async"/>`;
    document.body.appendChild(el);
    const img = el.querySelector('.dw__lightbox-img');
    guardImage(img);
    const close = () => { el.hidden = true; document.removeEventListener('keydown', onKey); };
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    el.addEventListener('click', (e) => {
      if (e.target === el || e.target.closest('.dw__lightbox-close')) close();
    });
    return { open(src) { img.src = src; el.hidden = false; document.addEventListener('keydown', onKey); } };
  })();
  const openLightbox = (src) => lightbox.open(src);
  els.previewImg.addEventListener('click', () => {
    if (state.generating) return;
    if (!state.previewUrl) return;
    openLightbox(state.previewUrl);
  });

  // Bevel comparison cards double as selectors: tapping a card (or its caption
  // below the photo) turns the 3D bevel on/off. The photo itself still opens
  // the fullscreen lightbox.
  els.bevelCompareItems.forEach((item, i) => {
    const wantBevel = i === 1;
    const selectBevel = () => {
      if (state.bevel === wantBevel) return;
      state.bevel = wantBevel;
      renderAll();
    };
    item.addEventListener('click', selectBevel);
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectBevel();
      }
    });
    const img = item.querySelector('.dw__bevel-compare-img');
    if (img) {
      img.addEventListener('click', (e) => {
        e.stopPropagation();
        openLightbox(img.src);
      });
    }
  });

  // Click step-2 style preview thumbnail to open fullscreen lightbox
  if (els.stylePreviewImg) {
    els.stylePreviewImg.addEventListener('click', () => {
      const img = els.stylePreviewImg.querySelector('img.dw__style-photo');
      if (img && img.src) openLightbox(img.src);
    });
  }

  // Footer nav
  els.btnPrev.addEventListener('click', () => goToStep(state.step - 1));
  els.btnNext.addEventListener('click', () => {
    if (state.step < 3) {
      if (!isStepValid(state.step)) {
        state.showErrors[state.step] = true;
        renderAll();
        showToast(t('error_complete_required_step'));
        return;
      }
      goToStep(state.step + 1);
    } else {
      if (!isAllValid()) {
        [0, 1, 2, 3].forEach(i => { if (!isStepValid(i)) state.showErrors[i] = true; });
        const target = firstInvalidStep();
        if (target !== undefined && target !== state.step) {
          goToStep(target);
        } else {
          renderAll();
        }
        showToast(t('error_complete_required_all'));
        return;
      }
      if (!state.previewUrl) {
        showToast(t('error_preview_required'));
        if (els.btnGenerate && typeof els.btnGenerate.scrollIntoView === 'function') {
          els.btnGenerate.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      addToCart();
    }
  });

  // ── Add to cart ──────────────────────────────────────────────────────────

  // The custom-fun-pet-sign product has a single option "Forma e dimensione"
  // whose values combine shape + size, e.g. "Circular - M". The 3D bevel is a
  // line-item property only — it never changes price, so it never changes
  // which variant we add to cart. Map the wizard state to the exact variant
  // title and look up the variant id.
  const SHAPE_TO_VARIANT = {
    'round':     'Circular',
    'rect':      'Rectangle',
    'rect-wide': 'Landscape',
    'square':    'Square',
    'shield':    'Shield',
  };
  const SIZE_TO_VARIANT = { S: 'M', L: 'L' };

  function findVariant(variants) {
    const shapeName = SHAPE_TO_VARIANT[state.shape];
    const sizeName  = SIZE_TO_VARIANT[state.size] || 'M';
    const wantedExact = shapeName + ' - ' + sizeName;

    const norm = s => (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const target = norm(wantedExact);
    const titleOf = v => norm(v.title || v.option1);
    const pool = variants.filter(v => v.available !== false);

    // SKU match first — SKUs (PWS-<SHAPE>-<SIZE>, e.g. PWS-RECT-WIDE-L) are
    // stable across locales. Storefront option labels may be translated via
    // catalog/i18n sync; title matching is an English-primary fallback only.
    const skuTarget = ('pws-' + state.shape + '-' + sizeName).toLowerCase();
    const skuOf = v => (v.sku || '').trim().toLowerCase();
    let match = pool.find(v => skuOf(v) === skuTarget);
    // Exact title match (shape + size)
    if (!match) match = pool.find(v => titleOf(v) === target);
    const exact = !!match;
    // Fallback: same shape, any size
    if (!match) match = pool.find(v => titleOf(v).startsWith(norm(shapeName) + ' - '));
    // Then: first available, then first
    if (!match) match = pool[0] || variants[0];

    if (!exact) {
      console.warn('[design-wizard] variant fallback', { wanted: wantedExact, picked: match && match.title });
    }
    return { match: match || null, exact };
  }

  // Variant titles in root.dataset.productVariants are rendered in the page
  // locale, so translated option values (via catalog/i18n sync) break the
  // English title matching above. The locale-prefix-free product URL always
  // serves the shop's primary locale — fetch it once as a fallback source of
  // untranslated titles. SKU matching above is preferred and locale-safe.
  let primaryVariants = null;
  async function fetchPrimaryLocaleVariants() {
    if (primaryVariants) return primaryVariants;
    const handle = root.dataset.productHandle;
    if (!handle) return null;
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        const product = await res.json();
        if (product && Array.isArray(product.variants) && product.variants.length) {
          primaryVariants = product.variants;
        }
      }
    } catch {}
    return primaryVariants;
  }

  async function pickVariantId() {
    let variants = [];
    try {
      const raw = root.dataset.productVariants;
      if (raw) variants = JSON.parse(raw);
    } catch {}
    if (!variants.length) return root.dataset.variantId || null;

    let { match, exact } = findVariant(variants);
    if (!exact) {
      const untranslated = await fetchPrimaryLocaleVariants();
      if (untranslated) {
        const retry = findVariant(untranslated);
        if (retry.exact) match = retry.match;
      }
    }
    return match ? String(match.id) : (root.dataset.variantId || null);
  }

  // Reads back the whole cart so the abandoned-cart email can show every
  // design in it, not just the one this add-to-cart created. Only the wizard's
  // own lines carry `_preview_image`, so anything else is skipped. Best-effort
  // by design: the redirect to /cart is waiting on this, so it gives up after
  // CART_READ_TIMEOUT_MS and the server falls back to the single-design
  // properties rather than the cart being tracked late or not at all.
  const CART_READ_TIMEOUT_MS = 800;
  async function readCartPreviewItems() {
    const abort = new AbortController();
    const timer = setTimeout(() => abort.abort(), CART_READ_TIMEOUT_MS);
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: abort.signal });
      if (!res.ok) return [];
      const cart = await res.json();
      return (cart && cart.items ? cart.items : []).reduce((items, line) => {
        const props = line.properties || {};
        if (typeof props._preview_image === 'string' && /^https:\/\//.test(props._preview_image)) {
          items.push({
            previewUrl: props._preview_image,
            shape: props._shape || '',
            quantity: line.quantity || 1,
          });
        }
        return items;
      }, []);
    } catch (err) {
      return [];
    } finally {
      clearTimeout(timer);
    }
  }

  let addingToCart = false;
  async function addToCart() {
    if (addingToCart) return;
    addingToCart = true;
    els.btnNext.disabled = true;
    els.btnNext.classList.add('is-loading');
    const previousLabel = els.btnNext.textContent;
    els.btnNext.textContent = t('nav_adding_to_cart');

    const variantId = await pickVariantId();
    const styleName = t('style_' + idKey(getStyle().id) + '_name') || getStyle().name;
    // Properties prefixed with `_` are stored on the order for fulfillment
    // but hidden from the customer-facing cart display by the cart templates.
    const properties = {
      [t('cart_shape')]:        t('shape_' + idKey(getShape().id)) || getShape().name,
      [t('cart_size')]:         t('size_' + sizeLabelKey(getSize().id) + '_label') || getSize().label,
      [t('cart_back_color')]:   t('back_color_' + state.backColor) || state.backColor,
      [t('cart_bevel')]:        state.bevel ? t('cart_bevel_yes') : t('cart_bevel_no'),
      ['_' + t('cart_breed')]:       state.petMode === 'upload' ? '' : (state.breed || ''),
      ['_' + t('cart_personality')]: state.personality || '',
      ['_' + t('cart_style')]:       state.styleMode === 'custom'
        ? t('cart_custom_prefix') + (state.customStyle || '')
        : state.styleMode === 'image'
          ? t('cart_style_image')
          : styleName,
      ['_' + t('cart_background')]:  state.bgDescription || '',
      ['_' + t('cart_sign_text')]:   normaliseSignText(state.signText) || '',
      ['_' + t('cart_text_style')]:  state.textStyle.trim() || '',
      ['_shape']:                    state.shape,
    };

    const restoreButton = () => {
      addingToCart = false;
      els.btnNext.disabled = false;
      els.btnNext.classList.remove('is-loading');
      els.btnNext.textContent = previousLabel;
    };

    if (!variantId) {
      console.error('[design-wizard] add to cart aborted: no product configured (custom-fun-pet-sign not found)');
      showToast(t('toast_error'));
      restoreButton();
      return;
    }

    // previewUrl is already the GCS URL the server returned at generation
    // time, so add-to-cart does no upload. Underscore-prefixed properties are
    // hidden from the customer-facing properties list; the cart templates
    // check for it explicitly to override item.image. (A data: fallback URL —
    // only when the bucket is unconfigured — isn't a usable cart image, so
    // skip it.)
    if (state.previewUrl && /^https:\/\//.test(state.previewUrl)) {
      properties._preview_image = state.previewUrl;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties }),
      });
      if (!res.ok) throw new Error(await res.text());
      track('pw_wizard_add_to_cart', {
        shape: state.shape, size: state.size, bevel: !!state.bevel,
        price: totalPrice(), variant_id: variantId,
      });
      // Tells the server this design made it into the cart. Two jobs, one
      // request (cloud-run/src/cart-add.ts): the audit page joins it onto the
      // generation by previewUrl so an operator can see which previews
      // converted, and — for identified customers only — the abandoned-cart
      // Klaviyo flow gets the design actually in the cart rather than whatever
      // was last generated (docs/klaviyo/ABANDONED-CART.md). Fired for
      // anonymous visitors too, since the audit half needs no identity. Same
      // https-only check as the /preview call; fire-and-forget, never blocks
      // the cart redirect.
      if (/^https:\/\//.test(state.previewUrl || '')) {
        const identified = CUSTOMER_LOGGED_IN && !!CUSTOMER_EMAIL;
        const cartAddBody = {
          locale: LOCALE,
          previewUrl: state.previewUrl,
          shape: state.shape,
          size: state.size,
          signText: normaliseSignText(state.signText),
          ...originFields(),
        };
        if (identified) {
          cartAddBody.email = CUSTOMER_EMAIL;
          if (CUSTOMER_FIRST_NAME) cartAddBody.firstName = CUSTOMER_FIRST_NAME;
          cartAddBody.productURL = window.location.origin + window.location.pathname;
          // Every design in the cart, not just the one just added — a customer
          // with two signs in the cart would otherwise get an abandoned-cart
          // email showing only the last one. Empty when /cart.js didn't answer
          // in time; the server then keeps the single-design properties it
          // already had. Read only for identified customers: it is the Klaviyo
          // email's payload, and awaiting it delays the redirect below.
          cartAddBody.items = await readCartPreviewItems();
        }
        fetch(CART_ADD_TRACK_ENDPOINT, {
          method: 'POST',
          // The redirect to /cart fires 150ms below, and a normal fetch is
          // cancelled the moment the page navigates — this request has to
          // survive it (App Proxy → Cloud Run is easily slower than that on
          // mobile), so hand it to the browser as a keepalive request.
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartAddBody),
        }).catch(() => {});
      }
      showToast(t('toast_added'));
      // Keep the button disabled during the redirect so the user can't
      // double-submit while the navigation is in flight.
      const cartUrl = state.discountCode
        ? '/cart?discount=' + encodeURIComponent(state.discountCode)
        : '/cart';
      setTimeout(() => { window.location.href = cartUrl; }, 150);
    } catch (err) {
      console.error('[design-wizard] add to cart failed', err);
      track('pw_wizard_add_to_cart_error', {});
      showToast(t('toast_error'));
      restoreButton();
    }
  }

  // ── Mobile keyboard viewport ─────────────────────────────────────────────
  // Chrome gets this natively from interactive-widget=resizes-content in the
  // page's viewport meta: the layout viewport itself shrinks, so 100dvh already
  // stops where the keyboard starts. Safari and Android in-app WebViews ignore
  // that keyword — they keep the layout viewport full height and *pan* it up so
  // the focused field clears the keyboard. That drags the fixed-height shell
  // off-screen (top bar first) and leaves the bare page showing under the
  // footer. Pinning the shell to the visual viewport — the slice the keyboard
  // leaves visible — puts it back over the visible area whatever the browser
  // does with the layout viewport.
  (function trackKeyboardViewport() {
    const vv = window.visualViewport;
    const shell = root.querySelector('.dw__shell');
    if (!vv || !shell) return;
    // The page never scrolls, so the tallest visual viewport seen is the
    // keyboard-closed height. innerHeight isn't usable: browsers disagree on
    // whether it shrinks with the keyboard.
    let tallest = vv.height;
    let keyboardOpen = false;

    function pinToVisualViewport() {
      const s = shell.style;
      if (!keyboardOpen) {
        s.position = s.top = s.left = s.width = s.height = '';
        return;
      }
      // position:fixed anchors to the *layout* viewport, so offsetTop/offsetLeft
      // — how far the visual viewport sits inside it — is exactly the correction
      // that moves the shell back over what the user can see.
      s.position = 'fixed';
      s.top = vv.offsetTop + 'px';
      s.left = vv.offsetLeft + 'px';
      s.width = vv.width + 'px';
      s.height = vv.height + 'px';
    }

    vv.addEventListener('resize', () => {
      // Pinch-zoom shrinks the visual viewport just like a keyboard does; scale
      // is what tells the two apart, and a zoomed viewport must not be treated
      // as the wizard's new size.
      const zoomed = vv.scale > 1.01;
      if (!zoomed) tallest = Math.max(tallest, vv.height);
      // A shrink smaller than this is browser chrome, not a keyboard.
      keyboardOpen = !zoomed && tallest - vv.height > 120;
      pinToVisualViewport();
      // Safari also grants the page extra scroll range for the keyboard and
      // scrolls it to reveal the focused field; with the whole wizard pinned
      // over the visible area there's nothing left to reveal, and a scrolled
      // page only exposes what sits below the shell.
      if (keyboardOpen && window.scrollY) window.scrollTo(0, 0);
    });
    // Panning the layout viewport inside the visual one fires scroll, not
    // resize — that's the drag that used to slide the shell away.
    vv.addEventListener('scroll', pinToVisualViewport);
  })();

  // ── Boot ─────────────────────────────────────────────────────────────────
  document.documentElement.classList.add('dw-open');
  document.body.classList.add('dw-open');

  async function readImageFromUrl(url, maxDim) {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch image: ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ ...resizeImageToJpegBase64(img, maxDim), objectUrl });
      };
      img.onerror = (e) => {
        URL.revokeObjectURL(objectUrl);
        reject(e);
      };
      img.src = objectUrl;
    });
  }

  (async function boot() {
    loadState();
    loadGeneratedSigs();
    initCharCounters();
    hydrateDeferredImages(state.step);
    const urlParams = new URLSearchParams(window.location.search);
    const discountParam = urlParams.get('discount');
    if (discountParam) state.discountCode = discountParam.trim();
    // Tracks whether *this* page load imported a style from the URL ("use this
    // style" in the gallery). state.stylePreFilled alone isn't enough — it is
    // persisted, so it stays true for a returning visitor mid-wizard.
    let styleImportedFromUrl = false;
    const styleImageUrl = urlParams.get('style_image');
    if (styleImageUrl) {
      try {
        const { data, mimeType, objectUrl } = await readImageFromUrl(styleImageUrl, 1280);
        state.styleMode = 'image';
        state.styleImageUrl = objectUrl;
        state.styleImageData = data;
        state.styleImageMime = mimeType;
        state.stylePreFilled = true;
        styleImportedFromUrl = true;
      } catch (err) {
        console.error('[design-wizard] failed to load gallery style image', err);
      }
    } else {
      const urlStyle = urlParams.get('style');
      if (urlStyle) {
        const promptMap = window.PW_STYLE_PROMPTS || {};
        const customPrompt = promptMap[urlStyle];
        if (customPrompt) {
          state.styleMode = 'custom';
          state.customStyle = customPrompt;
          state.stylePreFilled = true;
          styleImportedFromUrl = true;
        } else if (STYLES.some(s => s.id === urlStyle)) {
          state.style = urlStyle;
          state.styleMode = 'preset';
          state.stylePreFilled = true;
          styleImportedFromUrl = true;
        }
      }
    }

    // Arriving with a style already chosen still leaves shape, size and back
    // colour to pick, so always open on step 1 instead of wherever localStorage
    // left this visitor. Exception: the login gate sends them back to this same
    // URL — query string and all — and there the restored step is the point.
    const returningFromLogin = isLoginPending();
    if (styleImportedFromUrl && !returningFromLogin && state.step !== 0) {
      state.step = 0;
      hydrateDeferredImages(state.step);
    }

    track('pw_wizard_step_view', { step: state.step + 1 });
    renderAll();

    // Coming back from the account pages: loadState() has already restored the
    // step and every selection, so all that's left is to put the customer's eye
    // back on the preview they were about to regenerate. The marker only counts
    // as spent once the sign-in actually took — a customer who bounced off the
    // login page still has a journey in progress, and it may well finish in
    // another tab, which recheckLoginState() is watching for.
    if (CUSTOMER_LOGGED_IN) {
      clearLoginPending();
      try { sessionStorage.removeItem(LOGIN_RELOAD_KEY); } catch {}
      if (returningFromLogin) {
        // Back from the preview gate with the design, the step and the preview
        // all restored: say the sign-in took — the page looks identical to the
        // one they left, so nothing else would tell them — and put their eye
        // back on the button they were reaching for.
        track('pw_wizard_login_gate_returned', { generations_used: state.freeGenerationsUsed });
        showToast(t('toast_signed_in'));
        if (els.btnGenerate) setTimeout(() => scrollIntoViewSoftly(els.btnGenerate), 120);
      }
    } else if (returningFromLogin) {
      // Back from the login flow but rendered logged out — the case new customer
      // accounts hit most often. Settle it here instead of leaving the customer
      // to work out that a manual refresh is what the gate wants.
      pollForLoginAfterReturn();
    }
  })();
})();
